<template>
  <div @click="goToDashboardPage" class="home-button">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div v-on="on" class="home-button__icon">
          <svg
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              height="256px"
              viewBox="0 0 1080 1080"
              style="enable-background:new 0 0 1080 1080;"
              xml:space="preserve"
          >
            <g>
	<path class="st693" d="M354.7,976.3c1.6,5,3.4,10,5.2,15c2.5,6.5,5.1,13.1,7.6,19.6c4.1,11,8.3,21.8,12.4,32.8h-16
		c-2.2-8.4-3-11.7-8.8-25.6h-25.8c-2.6,4.8-5.3,9.5-7.8,14.4c-1.8,3.7-3.6,7.4-5.2,11.2h-15.1l35.3-67.4H354.7z M333.9,1007.6H352
		l-7.6-20.9L333.9,1007.6z"/>
              <path class="st693" d="M424.3,989c-5.5-1.4-11.2-3.1-16.9-3.1c-5,0-7.1,1.2-8.5,3.2c-0.3,0.4-1.1,1.6-1.1,3.1
		c0,2.6,2.1,4.5,3.9,6.2c3.6,2.9,7.1,5.8,10.7,8.8c2.8,2.4,5.5,4.9,8.2,7.4c1.6,1.8,5.7,5.7,5.7,12.5c0,2.6-0.7,8-5.9,12.4
		c-4.4,3.7-9.3,4.5-15,5.3c-11.1,0.2-13.7-0.3-24.1-3.3l-0.7-13c1.5,0.8,3,1.4,4.6,2.1c6.9,2.9,13.3,3.3,16.2,3.3
		c1.8,0,4.2-0.1,5.9-0.8c1-0.3,4.4-1.7,4.4-5.2c0-2.7-2.1-4.6-4.3-6.6c-2.2-1.9-4.4-3.8-6.6-5.7c-2.2-1.8-4.4-3.6-6.5-5.5
		c-1.4-1.3-2.9-2.7-4.3-4c-1.7-1.8-6.4-6.4-6.4-14c0-5.1,2.3-10.2,6.7-13.2c1.1-0.7,2.4-1.4,5-2.2c6.4-2,10.2-1.7,13.4-1.7
		c4.5,0.2,6.8,0.2,14.7,1.9L424.3,989z"/>
              <path class="st693" d="M448.8,976.3l-1.7,27h36.2c0.4-5.3,0.7-10.6,0.9-15.9c0.1-3.7,0.2-7.4,0.3-11.2l15,0.1
		c-0.9,12.1-1.7,24.3-2.3,36.5c-0.5,10.2-0.7,20.5-0.9,30.8h-14.9c0.5-7,1.1-13.9,1.3-21c0.1-2.6,0.1-5.3,0.2-8l-36.2,0.1
		c-0.3,6.7-0.7,13.5-0.8,20.3c-0.1,2.8-0.1,5.7-0.2,8.6h-15.1c1-12.8,1.8-25.6,2.3-38.4c0.4-9.7,0.6-19.4,0.7-29H448.8z"/>
              <path class="st693" d="M540.4,976.3c6.1,0.6,11.3,1.3,14.3,7c0.7,1.2,1.9,4.1,1.9,8.2c0,5.8-2.6,11.4-7.3,14.5
		c-1.4,1-2.6,1.5-6,2.6c1.6,0.3,3.8,0.8,5.3,1.3c8.8,3.3,9.2,11.3,9.2,14.3c0,1.1-0.1,2.6-0.6,4.8c-0.3,1.7-1.2,5.6-4.7,8.9
		c-1.7,1.7-3.7,3-5.9,3.8c-3.7,1.4-7.3,1.6-11.3,1.9h-30.4c0.6-6.2,1.2-12.3,1.4-18.6c0.6-9.7,0.8-19.4,1-29.1
		c0.1-6.5,0.2-13.1,0.3-19.7H540.4z M519.9,1032.7h12.5c3.9-0.3,7.2-0.5,9.6-3.7c0.8-1.1,1.9-2.9,1.9-5.9c0-1.3-0.1-4.4-2.9-6.5
		c-2.7-2.1-6.2-2-9.7-2h-10.5L519.9,1032.7z M520.9,1004.2h6.5c5.4-0.1,12-0.5,14.3-5.9c0.2-0.6,0.8-1.9,0.8-3.7
		c0-0.7-0.2-2.4-1.3-4c-2-2.8-5-2.9-8.4-3h-11.3L520.9,1004.2z"/>
              <path class="st693" d="M561.9,1009.4c0.2-2.7,0.3-4.2,1.3-9.1c1.6-5.2,2.9-8.6,6.3-12.8c1.2-1.2,3.2-3.6,6.6-6
		c4.8-3.2,8.6-4.2,14-5.7c3.8-0.6,6.6-1,10.5-1c2.4,0,4.8,0.2,9.8,0.8c3.6,0.9,6.3,1.5,9.6,3c7.5,3.2,11.4,8.2,13.2,10.7
		c3.8,5.7,4.5,10.5,5.4,17.2c0.1,3.6,0.2,4.7-0.9,10.6c-1.1,4.5-1.7,6.5-2.7,8.7c-1.4,3.3-5.4,10.3-14,14.7c-4,2.1-7.7,3-12.1,3.9
		c-3,0.2-6,0.5-8.9,0.5c-3.1,0-6.2-0.4-9.2-0.7c-2.8-0.7-5.3-1.3-8-2.2c-3.3-1.2-11-4.5-16.2-12.8c-3.7-6-4.2-11-4.7-17.8V1009.4z
		 M577.1,1018.9c3.3,10.2,12.4,14.5,22.9,14.5c1.7,0,6.9-0.1,11.6-2.2c8.7-3.8,13.1-12.2,13.1-21.6c-0.1-2.5-0.5-11.7-6.7-17.5
		c-2.5-2.2-8.2-5.7-16.8-5.7c-2.5,0-11.1,0.4-17.3,5.5c-3,2.5-7.8,8.4-7.9,18.8C575.8,1013.5,576.2,1016.4,577.1,1018.9z"/>
              <path class="st693" d="M691.2,976.3c1.6,5,3.4,10,5.2,15c2.5,6.5,5.1,13.1,7.6,19.6c4.1,11,8.3,21.8,12.4,32.8h-16
		c-2.2-8.4-3-11.7-8.8-25.6h-25.8c-2.6,4.8-5.3,9.5-7.8,14.4c-1.8,3.7-3.6,7.4-5.2,11.2h-15.1l35.3-67.4H691.2z M670.4,1007.6h18.1
		l-7.6-20.9L670.4,1007.6z"/>
              <path class="st693" d="M757.3,976.6c4.2,0.4,8.2,0.9,11.5,3.6c2.1,1.6,5.9,6,5.9,13.4c0,1-0.1,3.1-0.8,5.5
		c-0.7,2.6-2.8,8.6-8.9,12.4c-2.2,1.3-5.2,2.5-7.7,3.4l14.3,28.9h-16.3c-1.5-4-3.1-8-4.9-11.9c-1.7-3.9-3.7-7.9-5.5-11.7
		c-2.3-4.7-4.5-9.4-6.7-14c2.2,0.2,4.4,0.4,6.6,0.4c1.7,0,9.3-0.1,13.1-5.4c1.7-2.5,1.9-5.1,1.9-6.3c0-1.1-0.2-4-2.5-5.9
		c-1.4-1.2-2.7-1.5-6.5-1.7l-14.4,0.1c-0.9,13.2-1.6,26.3-2,39.5c-0.2,5.7-0.3,11.2-0.4,16.8h-14.8c0.7-7.2,1.2-14.4,1.5-21.7
		c0.3-5.6,0.5-11.2,0.7-16.8c0.3-6,0.6-11.8,0.7-17.8c0.1-3.6,0.1-7.1,0.1-10.7H757.3z"/>
              <path class="st693" d="M793.1,976.3c4.2-0.1,8.5-0.3,12.6-0.3c4.3,0,8.6,0.2,12.8,0.4c6.2,1,10.3,1.8,14.8,6.3
		c3,2.9,4.6,6.2,5.2,7.5c3,6.7,2.9,13,2.7,20.4c-0.6,6.6-0.9,8.1-2.8,14.4c-0.3,0.8-0.6,1.5-1,2.3c-1.2,2.6-3.9,8.8-10.9,12.7
		c-2.9,1.6-5.2,2.3-11.4,3.2c-5.2,0.3-10.3,0.6-15.6,0.6c-2.9,0-5.9-0.1-8.8-0.1c-4.4,0-8.8,0-13.3,0.1c0.5-5.8,1.1-11.5,1.3-17.3
		c0.2-4.7,0.3-9.4,0.6-14.1c0.3-6.6,0.7-13.4,0.9-20.1c0.2-5.3,0.2-10.6,0.3-15.9H793.1z M792.2,1032.1c4.4,0,8.9,0.1,13.3-0.2
		l4.9-0.3c0.3-0.1,3.1-0.5,4.8-1.2c1.6-0.6,5.2-2.1,7.8-6.2c3-4.6,4.6-11.9,4.6-17.3c0-2.9-0.3-14.3-10.7-18.1
		c-2.4-0.9-4.4-1-6.9-1.2h-15.8L792.2,1032.1z"/>
</g>
            <g>
	<g>
		<g>
			<path class="st708" d="M602.9,167.3C602.8,167.3,602.8,167.3,602.9,167.3l-0.1,0l0,0c-0.8-0.3-1.9-0.1-3,0.5l-146,84.3
				c-2.7,1.5-4.8,5.3-4.8,8.3v12.8v97.5c0,1.6,0.6,2.7,1.5,3.1l0,0l0.1,0c0.1,0.1,0.3,0.1,0.4,0.2l1.7-0.1c0.4-0.1,0.8-0.3,1.2-0.5
				l146-84.3c2.7-1.5,4.8-5.3,4.8-8.3v-97.5v-12.8c0-1-0.2-1.8-0.7-2.4L602.9,167.3z"/>
		</g>
    <path class="st709" d="M702.3,104.3l-3.9-1.5c0,0-0.1,0-0.1,0l-0.1,0l0,0c-1.6-0.5-3.6-0.2-5.8,1L405.8,269.3
			c-5.2,3-9.4,10.3-9.4,16.4v25.2v191.4c0,3.1,1.1,5.2,2.9,6.2l0,0l0.1,0c0.3,0.1,0.5,0.2,0.8,0.3l3.4,1.3l0-1.4
			c0.7-0.2,1.5-0.5,2.3-1l286.6-165.4c5.2-3,9.4-10.3,9.4-16.4V134.5v-25.2c0-2-0.5-3.6-1.3-4.7L702.3,104.3z"/>
    <g>
			<path class="st697"
            d="M400.3,312.3v191.4c0,6,4.2,8.5,9.4,5.5l286.6-165.4c5.2-3,9.4-10.3,9.4-16.4V135.9L400.3,312.3z"/>
      <path class="st702"
            d="M705.8,110.8c0-6-4.2-8.5-9.4-5.5L409.7,270.7c-5.2,3-9.4,10.3-9.4,16.4v25.2l305.5-176.4V110.8z"/>
		</g>
    <g>
			<path class="st406" d="M662,143.2c0,2.6-1.8,5.8-4.1,7.2c-2.3,1.3-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2
				C660.1,139.5,662,140.5,662,143.2z"/>
      <path class="st406" d="M676.9,134.5c0,2.6-1.8,5.8-4.1,7.2s-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2
				C675.1,130.8,676.9,131.9,676.9,134.5z"/>
      <path class="st406" d="M691.9,125.9c0,2.6-1.8,5.8-4.1,7.2c-2.3,1.3-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2
				C690.1,122.2,691.9,123.2,691.9,125.9z"/>
		</g>
    <polygon class="st706" points="498.3,384.2 424.6,427.9 424.6,379.5 498.3,335.8 		"/>
    <g>
			<g>

					<linearGradient id="SVGID_00000155835951113341818820000001492619998238346430_" gradientUnits="userSpaceOnUse"
                          x1="1217.6221" y1="2825.5488" x2="1222.8665" y2="2816.4651"
                          gradientTransform="matrix(0.866 -0.5 0 1.1547 -628.4642 -2199.9353)">
					<stop offset="0" style="stop-color:#66BC52"/>
            <stop offset="1" style="stop-color:#3B60AB"/>
				</linearGradient>
        <polygon style="fill:url(#SVGID_00000155835951113341818820000001492619998238346430_);" points="431.9,449.5 424.6,453.7
					424.6,445.3 431.9,441.1 				"/>
        <polygon class="st711" points="457.5,434.5 431.9,449.5 431.9,441.1 457.5,426.1 				"/>
        <polygon class="st711" points="457.5,445.6 431.9,460.5 431.9,452.1 457.5,437.2 				"/>
        <polygon class="st711" points="457.5,457.1 431.9,472 431.9,463.6 457.5,448.7 				"/>

        <linearGradient id="SVGID_00000111160158961827755650000013442709410423107234_" gradientUnits="userSpaceOnUse"
                        x1="1217.6219" y1="2835.0901" x2="1222.8665" y2="2826.0063"
                        gradientTransform="matrix(0.866 -0.5 0 1.1547 -628.4642 -2199.9353)">
					<stop offset="0" style="stop-color:#F7D322"/>
          <stop offset="1" style="stop-color:#EF5153"/>
				</linearGradient>
        <polygon style="fill:url(#SVGID_00000111160158961827755650000013442709410423107234_);" points="431.9,460.5 424.6,464.7
					424.6,456.3 431.9,452.1 				"/>
			</g>

      <linearGradient id="SVGID_00000120516955154571879620000005036144643636006016_" gradientUnits="userSpaceOnUse"
                      x1="1217.6221" y1="2845.0894" x2="1222.8665" y2="2836.0059"
                      gradientTransform="matrix(0.866 -0.5 0 1.1547 -628.4642 -2199.9353)">
				<stop offset="0" style="stop-color:#EF5D7D"/>
        <stop offset="1" style="stop-color:#6D7CBB"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000120516955154571879620000005036144643636006016_);" points="431.9,472 424.6,476.2
				424.6,467.8 431.9,463.6 			"/>
		</g>
    <g>

				<linearGradient id="SVGID_00000080918915794823566460000015028336426427251378_" gradientUnits="userSpaceOnUse"
                        x1="472.2697" y1="425.5295" x2="497.9081" y2="425.5295">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
          <stop offset="0.2003" style="stop-color:#237761"/>
          <stop offset="0.4783" style="stop-color:#2D8A70"/>
          <stop offset="0.8012" style="stop-color:#3DA788"/>
          <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000080918915794823566460000015028336426427251378_);" points="497.9,422.3 472.3,437.2
				472.3,428.8 497.9,413.9 			"/>

      <linearGradient id="SVGID_00000154385708765579587510000017725289534970217881_" gradientUnits="userSpaceOnUse"
                      x1="472.2697" y1="437.0756" x2="497.9081" y2="437.0756">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
        <stop offset="0.2003" style="stop-color:#237761"/>
        <stop offset="0.4783" style="stop-color:#2D8A70"/>
        <stop offset="0.8012" style="stop-color:#3DA788"/>
        <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000154385708765579587510000017725289534970217881_);" points="497.9,433.8 472.3,448.7
				472.3,440.3 497.9,425.4 			"/>

      <linearGradient id="SVGID_00000003105783508781461670000016078737958109692314_" gradientUnits="userSpaceOnUse"
                      x1="472.2697" y1="414.5122" x2="497.9081" y2="414.5122">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
        <stop offset="0.2003" style="stop-color:#237761"/>
        <stop offset="0.4783" style="stop-color:#2D8A70"/>
        <stop offset="0.8012" style="stop-color:#3DA788"/>
        <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000003105783508781461670000016078737958109692314_);" points="497.9,411.2 472.3,426.2
				472.3,417.8 497.9,402.9 			"/>
      <polygon class="st717" points="472.3,426.2 465,430.4 465,422 472.3,417.8 			"/>
      <polygon class="st717" points="472.3,437.2 465,441.4 465,433 472.3,428.8 			"/>
      <polygon class="st717" points="472.3,448.7 465,452.9 465,444.5 472.3,440.3 			"/>
		</g>
    <g>
			<path class="st717" d="M613.8,236.1L613.8,236.1l0-28.7c-32.7,18.9-60.2,60.1-68.7,99.6l24-6
				C574.7,275.2,592.6,248.3,613.8,236.1z"/>
      <path class="st718" d="M567.4,316.6c0-5.1,0.7-10.3,1.8-15.6l-24,6c-1.7,8.1-2.7,16.2-2.7,24c0,0.6,0,1.2,0,1.8l24.9-15
				C567.4,317.3,567.4,317,567.4,316.6z"/>
      <path class="st704"
            d="M657.4,246.2l23.5-23.4c-10-25.8-36.2-33.3-67.1-15.5v28.7C633.9,224.5,650.9,229.4,657.4,246.2z"/>
      <path class="st719" d="M680.9,222.8l-23.5,23.4c1.8,4.7,2.9,10.2,2.9,16.7c0,1.4-0.1,2.8-0.2,4.3l24.8-12.1
				c0.1-2.2,0.2-4.4,0.2-6.5C685.2,238.6,683.7,230,680.9,222.8z"/>
      <path class="st702" d="M613.8,343.4c-25.3,14.6-45.9,3-46.4-25.7l-24.9,15c0.8,44.2,32.4,61.8,71.3,39.4
				c7.2-4.1,14.1-9.3,20.6-15.4l-7.2-23.4C623,337.3,618.5,340.7,613.8,343.4z"/>
      <path class="st720"
            d="M627.2,333.4l7.2,23.4c27.7-25.6,48.3-66,50.5-101.7l-24.8,12.1C658.6,290.4,645.2,316.7,627.2,333.4z"/>
		</g>
    <g>

				<linearGradient id="SVGID_00000176001253106844903300000004296813598058815893_" gradientUnits="userSpaceOnUse"
                        x1="1205.8062" y1="2701.3489" x2="1205.8062" y2="2672.1973"
                        gradientTransform="matrix(0.866 -0.5 0 1.1547 -611.8783 -2158.238)">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
          <stop offset="0.2003" style="stop-color:#237761"/>
          <stop offset="0.4783" style="stop-color:#2D8A70"/>
          <stop offset="0.8012" style="stop-color:#3DA788"/>
          <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000176001253106844903300000004296813598058815893_);" points="428.7,326.5 436,322.4 436,356
				428.7,360.2 			"/>

      <linearGradient id="SVGID_00000139981361626861124010000003892534581985576368_" gradientUnits="userSpaceOnUse"
                      x1="1246.1626" y1="2701.3513" x2="1246.1626" y2="2677.9949"
                      gradientTransform="matrix(0.866 -0.5 0 1.1547 -611.8783 -2158.238)">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
        <stop offset="0.2003" style="stop-color:#237761"/>
        <stop offset="0.4783" style="stop-color:#2D8A70"/>
        <stop offset="0.8012" style="stop-color:#3DA788"/>
        <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000139981361626861124010000003892534581985576368_);" points="463.7,313 470.9,308.9
				470.9,335.8 463.7,340 			"/>

      <linearGradient id="SVGID_00000000213953080542322810000001429982148584569498_" gradientUnits="userSpaceOnUse"
                      x1="1259.6147" y1="2701.3503" x2="1259.6147" y2="2686.7803"
                      gradientTransform="matrix(0.866 -0.5 0 1.1547 -611.8783 -2158.238)">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
        <stop offset="0.2003" style="stop-color:#237761"/>
        <stop offset="0.4783" style="stop-color:#2D8A70"/>
        <stop offset="0.8012" style="stop-color:#3DA788"/>
        <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000000213953080542322810000001429982148584569498_);" points="475.3,316.5 482.6,312.3
				482.6,329.1 475.3,333.3 			"/>

      <linearGradient id="SVGID_00000173139311248538536700000009539441731229239726_" gradientUnits="userSpaceOnUse"
                      x1="1219.2583" y1="2701.3479" x2="1219.2583" y2="2686.1482"
                      gradientTransform="matrix(0.866 -0.5 0 1.1547 -611.8783 -2158.238)">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
        <stop offset="0.2003" style="stop-color:#237761"/>
        <stop offset="0.4783" style="stop-color:#2D8A70"/>
        <stop offset="0.8012" style="stop-color:#3DA788"/>
        <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000173139311248538536700000009539441731229239726_);" points="440.4,335.9 447.6,331.7
				447.6,349.3 440.4,353.5 			"/>

      <linearGradient id="SVGID_00000045589304277776322410000001072471386547971481_" gradientUnits="userSpaceOnUse"
                      x1="1273.0668" y1="2701.3511" x2="1273.0668" y2="2676.0425"
                      gradientTransform="matrix(0.866 -0.5 0 1.1547 -611.8783 -2158.238)">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
        <stop offset="0.2003" style="stop-color:#237761"/>
        <stop offset="0.4783" style="stop-color:#2D8A70"/>
        <stop offset="0.8012" style="stop-color:#3DA788"/>
        <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000045589304277776322410000001072471386547971481_);" points="487,297.3 494.2,293.2
				494.2,322.4 487,326.6 			"/>

      <linearGradient id="SVGID_00000170252922618597246300000009982885160858838969_" gradientUnits="userSpaceOnUse"
                      x1="1232.7104" y1="2701.3506" x2="1232.7104" y2="2659.6382"
                      gradientTransform="matrix(0.866 -0.5 0 1.1547 -611.8783 -2158.238)">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
        <stop offset="0.2003" style="stop-color:#237761"/>
        <stop offset="0.4783" style="stop-color:#2D8A70"/>
        <stop offset="0.8012" style="stop-color:#3DA788"/>
        <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
      <polygon style="fill:url(#SVGID_00000170252922618597246300000009982885160858838969_);" points="452,298.6 459.3,294.4
				459.3,342.6 452,346.7 			"/>
		</g>
	</g>
              <g>
		<path class="st709" d="M492.2,405.8l-3.9-1.5c0,0-0.1,0-0.1,0l-0.1,0l0,0c-1.6-0.5-3.6-0.2-5.8,1L195.7,570.8
			c-5.2,3-9.4,10.3-9.4,16.4v25.2v191.4c0,3.1,1.1,5.2,2.9,6.2l0,0l0.1,0c0.3,0.1,0.5,0.2,0.8,0.3l3.4,1.3l0-1.4
			c0.7-0.2,1.5-0.5,2.3-1l286.6-165.4c5.2-3,9.4-10.3,9.4-16.4V436v-25.2c0-2-0.5-3.6-1.3-4.7L492.2,405.8z"/>
                <g>
			<path class="st697"
            d="M190.4,613.9v191.4c0,6,4.2,8.5,9.4,5.5l286.6-165.4c5.2-3,9.4-10.3,9.4-16.4V437.5L190.4,613.9z"/>
                  <path class="st406"
                        d="M495.8,413c0-6-4.2-8.5-9.4-5.5L199.8,573c-5.2,3-9.4,10.3-9.4,16.4v25.2l305.5-176.4V413z"/>
		</g>
                <g>
			<path class="st727" d="M452,444.7c0,2.6-1.8,5.8-4.1,7.2c-2.3,1.3-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2
				C450.2,441,452,442.1,452,444.7z"/>
                  <path class="st728" d="M467,436.1c0,2.6-1.8,5.8-4.1,7.2c-2.3,1.3-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2
				C465.1,432.4,467,433.5,467,436.1z"/>
                  <path class="st729" d="M482,427.5c0,2.6-1.8,5.8-4.1,7.2c-2.3,1.3-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2
				C480.1,423.7,482,424.8,482,427.5z"/>
		</g>
                <polygon class="st730" points="489.1,531.1 415.4,574.8 415.4,557.1 489.1,513.4 		"/>
                <polygon class="st730" points="489.1,565.9 415.4,609.6 415.4,591.9 489.1,548.1 		"/>
                <polygon class="st730" points="489.1,631.3 415.4,675 415.4,626.6 489.1,582.9 		"/>
                <g>

				<linearGradient id="SVGID_00000137131799013945606260000007625749749184032429_" gradientUnits="userSpaceOnUse"
                        x1="-8801.7412" y1="-5571.4829" x2="-8801.7412" y2="-5591.6909"
                        gradientTransform="matrix(-1.400000e-03 -1 -0.9992 0.5787 -5376.395 -4878.207)">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
          <stop offset="0.2003" style="stop-color:#237761"/>
          <stop offset="0.4783" style="stop-color:#2D8A70"/>
          <stop offset="0.8012" style="stop-color:#3DA788"/>
          <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
                  <polygon style="fill:url(#SVGID_00000137131799013945606260000007625749749184032429_);" points="223.2,692.6 223.1,682.6
				202.9,694.3 203,704.3 			"/>

                  <linearGradient id="SVGID_00000099654804986806120090000011344025560073978302_"
                                  gradientUnits="userSpaceOnUse" x1="-8785.6758" y1="-5571.4829" x2="-8785.6758"
                                  y2="-5599.3779"
                                  gradientTransform="matrix(-1.400000e-03 -1 -0.9992 0.5787 -5376.395 -4878.207)">
				<stop offset="1.071477e-03" style="stop-color:#6B59A6"/>
                    <stop offset="0.1675" style="stop-color:#695FA5"/>
                    <stop offset="0.3997" style="stop-color:#6371A3"/>
                    <stop offset="0.6707" style="stop-color:#598F9F"/>
                    <stop offset="0.969" style="stop-color:#4BB89A"/>
                    <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
                  <polygon style="fill:url(#SVGID_00000099654804986806120090000011344025560073978302_);" points="230.8,672.1 230.8,662.1
				202.9,678.3 202.9,688.2 			"/>

                  <linearGradient id="SVGID_00000163778245413146288640000011217776933967032740_"
                                  gradientUnits="userSpaceOnUse" x1="-8737.4795" y1="-5571.4834" x2="-8737.4795"
                                  y2="-5608.0049"
                                  gradientTransform="matrix(-1.400000e-03 -1 -0.9992 0.5787 -5376.395 -4878.207)">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
                    <stop offset="0.2003" style="stop-color:#237761"/>
                    <stop offset="0.4783" style="stop-color:#2D8A70"/>
                    <stop offset="0.8012" style="stop-color:#3DA788"/>
                    <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
                  <polygon style="fill:url(#SVGID_00000163778245413146288640000011217776933967032740_);" points="239.4,618.9 239.3,608.9
				202.9,630.1 202.9,640 			"/>

                  <linearGradient id="SVGID_00000119113226593048653870000010277637027391770241_"
                                  gradientUnits="userSpaceOnUse" x1="-8753.5449" y1="-5571.4839" x2="-8753.5449"
                                  y2="-5589.6372"
                                  gradientTransform="matrix(-1.400000e-03 -1 -0.9992 0.5787 -5376.395 -4878.207)">
				<stop offset="1.071477e-03" style="stop-color:#6B59A6"/>
                    <stop offset="0.1675" style="stop-color:#695FA5"/>
                    <stop offset="0.3997" style="stop-color:#6371A3"/>
                    <stop offset="0.6707" style="stop-color:#598F9F"/>
                    <stop offset="0.969" style="stop-color:#4BB89A"/>
                    <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
                  <polygon style="fill:url(#SVGID_00000119113226593048653870000010277637027391770241_);" points="221,645.6 221,635.6
				202.9,646.1 202.9,656.1 			"/>

                  <linearGradient id="SVGID_00000057132889193191043130000000437357553432852110_"
                                  gradientUnits="userSpaceOnUse" x1="-8721.4141" y1="-5571.4829" x2="-8721.4141"
                                  y2="-5582.7876"
                                  gradientTransform="matrix(-1.400000e-03 -1 -0.9992 0.5787 -5376.395 -4878.207)">
				<stop offset="1.071477e-03" style="stop-color:#6B59A6"/>
                    <stop offset="0.1675" style="stop-color:#695FA5"/>
                    <stop offset="0.3997" style="stop-color:#6371A3"/>
                    <stop offset="0.6707" style="stop-color:#598F9F"/>
                    <stop offset="0.969" style="stop-color:#4BB89A"/>
                    <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
                  <polygon style="fill:url(#SVGID_00000057132889193191043130000000437357553432852110_);" points="214.1,617.4 214.1,607.5
				202.8,614 202.8,624 			"/>

                  <linearGradient id="SVGID_00000173841923868663025050000013836712735526471301_"
                                  gradientUnits="userSpaceOnUse" x1="-8769.6104" y1="-5571.4824" x2="-8769.6104"
                                  y2="-5621.3003"
                                  gradientTransform="matrix(-1.400000e-03 -1 -0.9992 0.5787 -5376.395 -4878.207)">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
                    <stop offset="0.2003" style="stop-color:#237761"/>
                    <stop offset="0.4783" style="stop-color:#2D8A70"/>
                    <stop offset="0.8012" style="stop-color:#3DA788"/>
                    <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
                  <polygon style="fill:url(#SVGID_00000173841923868663025050000013836712735526471301_);" points="252.7,643.3 252.7,633.4
				202.9,662.2 202.9,672.2 			"/>
		</g>
                <polygon class="st730" points="273.3,753.9 202.8,794.4 202.8,776.7 273.3,736.2 		"/>
                <polygon class="st730" points="273.3,718.1 202.8,758.6 202.8,717.4 273.3,676.9 		"/>
                <g>
			<g>
				<polygon class="st737" points="422.6,512.1 415.4,516.3 415.4,507.9 422.6,503.7 				"/>

        <linearGradient id="SVGID_00000078734232224021332850000006457966955584513725_" gradientUnits="userSpaceOnUse"
                        x1="422.6473" y1="500.4079" x2="448.2858" y2="500.4079">
					<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
          <stop offset="0.2003" style="stop-color:#237761"/>
          <stop offset="0.4783" style="stop-color:#2D8A70"/>
          <stop offset="0.8012" style="stop-color:#3DA788"/>
          <stop offset="1" style="stop-color:#49BD99"/>
				</linearGradient>
        <polygon style="fill:url(#SVGID_00000078734232224021332850000006457966955584513725_);" points="448.3,497.1 422.6,512.1
					422.6,503.7 448.3,488.8 				"/>

        <linearGradient id="SVGID_00000108987140357471033490000010669824786481183895_" gradientUnits="userSpaceOnUse"
                        x1="422.6473" y1="511.4253" x2="448.2858" y2="511.4253">
					<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
          <stop offset="0.2003" style="stop-color:#237761"/>
          <stop offset="0.4783" style="stop-color:#2D8A70"/>
          <stop offset="0.8012" style="stop-color:#3DA788"/>
          <stop offset="1" style="stop-color:#49BD99"/>
				</linearGradient>
        <polygon style="fill:url(#SVGID_00000108987140357471033490000010669824786481183895_);" points="448.3,508.2 422.6,523.1
					422.6,514.7 448.3,499.8 				"/>

        <linearGradient id="SVGID_00000114789800433269113910000004061753508460524979_" gradientUnits="userSpaceOnUse"
                        x1="422.6473" y1="522.9714" x2="448.2858" y2="522.9714">
					<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
          <stop offset="0.2003" style="stop-color:#237761"/>
          <stop offset="0.4783" style="stop-color:#2D8A70"/>
          <stop offset="0.8012" style="stop-color:#3DA788"/>
          <stop offset="1" style="stop-color:#49BD99"/>
				</linearGradient>
        <polygon style="fill:url(#SVGID_00000114789800433269113910000004061753508460524979_);" points="448.3,519.7 422.6,534.6
					422.6,526.2 448.3,511.3 				"/>
        <polygon class="st737" points="422.6,523.1 415.4,527.3 415.4,518.9 422.6,514.7 				"/>
			</g>
                  <polygon class="st737" points="422.6,534.6 415.4,538.8 415.4,530.4 422.6,526.2 			"/>
		</g>
                <g>

				<linearGradient id="SVGID_00000016075228467949321770000009931027283861299089_" gradientUnits="userSpaceOnUse"
                        x1="463.0161" y1="488.1357" x2="488.6546" y2="488.1357">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
          <stop offset="0.2003" style="stop-color:#237761"/>
          <stop offset="0.4783" style="stop-color:#2D8A70"/>
          <stop offset="0.8012" style="stop-color:#3DA788"/>
          <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
                  <polygon style="fill:url(#SVGID_00000016075228467949321770000009931027283861299089_);" points="488.7,484.9 463,499.8
				463,491.4 488.7,476.5 			"/>

                  <linearGradient id="SVGID_00000167389479267566718250000007681197736974283959_"
                                  gradientUnits="userSpaceOnUse" x1="463.0161" y1="499.6818" x2="488.6546"
                                  y2="499.6818">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
                    <stop offset="0.2003" style="stop-color:#237761"/>
                    <stop offset="0.4783" style="stop-color:#2D8A70"/>
                    <stop offset="0.8012" style="stop-color:#3DA788"/>
                    <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
                  <polygon style="fill:url(#SVGID_00000167389479267566718250000007681197736974283959_);" points="488.7,496.4 463,511.3
				463,502.9 488.7,488 			"/>

                  <linearGradient id="SVGID_00000004508533722110546570000016739379208393671858_"
                                  gradientUnits="userSpaceOnUse" x1="463.0161" y1="477.1184" x2="488.6546"
                                  y2="477.1184">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
                    <stop offset="0.2003" style="stop-color:#237761"/>
                    <stop offset="0.4783" style="stop-color:#2D8A70"/>
                    <stop offset="0.8012" style="stop-color:#3DA788"/>
                    <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
                  <polygon style="fill:url(#SVGID_00000004508533722110546570000016739379208393671858_);" points="488.7,473.9 463,488.8
				463,480.4 488.7,465.5 			"/>
                  <polygon class="st737" points="463,488.8 455.7,493 455.7,484.6 463,480.4 			"/>
                  <polygon class="st737" points="463,499.8 455.7,504 455.7,495.6 463,491.4 			"/>
                  <polygon class="st737" points="463,511.3 455.7,515.5 455.7,507.1 463,502.9 			"/>
		</g>
                <g>
			<polygon class="st744" points="407.1,512.6 407.1,533.1 285.7,603.2 285.7,583.3 			"/>
                  <polygon class="st745" points="306.9,639.5 341,619.9 341,606.1 306.9,625.7 			"/>
                  <polygon class="st745" points="307.5,614.1 341.6,594.4 341.6,580.6 307.5,600.3 			"/>
                  <g>
				<g class="st746">
					<g>
						<path class="st406" d="M290.2,684.4l117.7-68l0.3-0.2l0,21.9l-117.7,68l-0.3,0.2L290.2,684.4z M407.1,618.2l-115.7,66.8
							l0,19.3l115.7-66.8L407.1,618.2z"/>
					</g>
          <g>
						<path class="st406" d="M290.2,663.9l117.7-68l0.3-0.2l0,21.9l-117.7,68l-0.3,0.2L290.2,663.9z M407.1,597.7l-115.8,66.8
							l0,19.3l115.7-66.8L407.1,597.7z"/>
					</g>
          <g>
						<path class="st406" d="M290.2,705L408,637l0.3-0.2v21.9l-117.7,68l-0.3,0.2L290.2,705z M407.1,638.8l-115.7,66.8l0,19.3
							L407.1,658L407.1,638.8z"/>
					</g>
          <g>
						<path class="st406" d="M290.2,725.5l117.7-68l0.3-0.2l0,21.9l-117.7,68l-0.3,0.2L290.2,725.5z M407.1,659.3l-115.8,66.8
							l0,19.3l115.8-66.8L407.1,659.3z"/>
					</g>
				</g>
                    <g>
					<polygon class="st744" points="390.5,688.2 407.1,678.6 407.1,606.1 390.5,615.6 					"/>

                      <linearGradient id="SVGID_00000026153660570856650640000004396857877007890847_"
                                      gradientUnits="userSpaceOnUse" x1="-8606.9033" y1="3495.5571" x2="-8606.9033"
                                      y2="3454.7732"
                                      gradientTransform="matrix(-0.866 0.5 0 1.1548 -7071.3569 959.7469)">
						<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
                        <stop offset="0.2003" style="stop-color:#237761"/>
                        <stop offset="0.4783" style="stop-color:#2D8A70"/>
                        <stop offset="0.8012" style="stop-color:#3DA788"/>
                        <stop offset="1" style="stop-color:#49BD99"/>
					</linearGradient>
                      <polygon style="fill:url(#SVGID_00000026153660570856650640000004396857877007890847_);" points="373.9,697.8 390.5,688.2
						390.5,641.1 373.9,650.7 					"/>
				</g>
                    <g>
					<polygon class="st744" points="308,735.8 324.5,726.3 324.5,672.7 308,682.3 					"/>

                      <linearGradient id="SVGID_00000173134994467582298300000008387786644040782733_"
                                      gradientUnits="userSpaceOnUse" x1="-8511.5615" y1="3495.5562" x2="-8511.5615"
                                      y2="3445.1919"
                                      gradientTransform="matrix(-0.866 0.5 0 1.1548 -7071.3569 959.7469)">
						<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
                        <stop offset="0.2003" style="stop-color:#237761"/>
                        <stop offset="0.4783" style="stop-color:#2D8A70"/>
                        <stop offset="0.8012" style="stop-color:#3DA788"/>
                        <stop offset="1" style="stop-color:#49BD99"/>
					</linearGradient>
                      <polygon style="fill:url(#SVGID_00000173134994467582298300000008387786644040782733_);" points="291.4,745.4 308,735.8
						308,677.7 291.4,687.3 					"/>
				</g>
                    <g>
					<polygon class="st744" points="349.7,711.6 366.3,702 366.2,654.2 349.6,663.7 					"/>

                      <linearGradient id="SVGID_00000047782452153456542470000010394339015043214464_"
                                      gradientUnits="userSpaceOnUse" x1="-8559.6572" y1="3495.4561" x2="-8559.6572"
                                      y2="3464.6196"
                                      gradientTransform="matrix(-0.866 0.5 0 1.1548 -7071.3569 959.7469)">
						<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
                        <stop offset="0.2003" style="stop-color:#237761"/>
                        <stop offset="0.4783" style="stop-color:#2D8A70"/>
                        <stop offset="0.8012" style="stop-color:#3DA788"/>
                        <stop offset="1" style="stop-color:#49BD99"/>
					</linearGradient>
                      <polygon style="fill:url(#SVGID_00000047782452153456542470000010394339015043214464_);" points="333.1,721.2 349.7,711.6
						349.5,676.1 332.9,685.7 					"/>
				</g>
			</g>
                  <polygon class="st750" points="290.2,649.4 302.5,642.4 302.5,628.2 290.2,635.3 			"/>
                  <polygon class="st750" points="290.2,624.8 302.5,617.8 302.5,603.6 290.2,610.7 			"/>
                  <polygon class="st745" points="375.3,574.7 405,557.9 405,544.1 375.3,560.9 			"/>
                  <polygon class="st750" points="357.9,585.5 370.2,578.4 370.2,564.3 357.9,571.3 			"/>
                  <polygon class="st745" points="375.3,599.7 405,582.9 405,569.1 375.3,586 			"/>
                  <polygon class="st750" points="357.9,610.5 370.2,603.4 370.2,589.3 357.9,596.3 			"/>
		</g>
	</g>
              <g>
		<path class="st709" d="M890.1,250.9l-3.9-1.5c0,0-0.1,0-0.1,0l-0.1,0l0,0c-1.6-0.5-3.6-0.2-5.8,1L593.6,415.9
			c-5.2,3-9.4,10.3-9.4,16.4v25.2v191.4c0,3.1,1.1,5.2,2.9,6.2l0,0l0.1,0c0.3,0.1,0.5,0.2,0.8,0.3l3.4,1.3l0-1.4
			c0.7-0.2,1.5-0.5,2.3-1l286.6-165.4c5.2-3,9.4-10.3,9.4-16.4V281.1v-25.2c0-2-0.5-3.6-1.3-4.7L890.1,250.9z"/>
                <g>
			<path class="st697"
            d="M588.3,459v191.4c0,6,4.2,8.5,9.4,5.5l286.6-165.4c5.2-3,9.4-10.3,9.4-16.4V282.6L588.3,459z"/>
                  <path class="st702"
                        d="M893.7,257.4c0-6-4.2-8.5-9.4-5.5L597.7,417.4c-5.2,3-9.4,10.3-9.4,16.4V459l305.5-176.4V257.4z"/>
		</g>
                <g>
			<path class="st727" d="M850,289.9c0,2.6-1.8,5.8-4.1,7.2c-2.3,1.3-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2
				C848.1,286.2,850,287.2,850,289.9z"/>
                  <path class="st728" d="M864.9,281.2c0,2.6-1.8,5.8-4.1,7.2s-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2
				C863.1,277.5,864.9,278.6,864.9,281.2z"/>
                  <path class="st729" d="M879.9,272.6c0,2.6-1.8,5.8-4.1,7.2c-2.3,1.3-4.1,0.2-4.1-2.4c0-2.6,1.8-5.8,4.1-7.2
				C878.1,268.9,879.9,269.9,879.9,272.6z"/>
		</g>
                <polygon class="st730" points="887,376.2 813.3,419.9 813.3,402.2 887,358.5 		"/>
                <polygon class="st730" points="887,411 813.3,454.7 813.3,437 887,393.3 		"/>
                <polygon class="st730" points="887,476.4 813.3,520.1 813.3,471.7 887,428 		"/>
                <g>
			<g>
				<polygon class="st717" points="820.6,357.2 813.3,361.4 813.3,353 820.6,348.8 				"/>

        <linearGradient id="SVGID_00000048477462083317142730000001647801330545237920_" gradientUnits="userSpaceOnUse"
                        x1="820.5844" y1="345.5163" x2="846.2228" y2="345.5163">
					<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
          <stop offset="0.2003" style="stop-color:#237761"/>
          <stop offset="0.4783" style="stop-color:#2D8A70"/>
          <stop offset="0.8012" style="stop-color:#3DA788"/>
          <stop offset="1" style="stop-color:#49BD99"/>
				</linearGradient>
        <polygon style="fill:url(#SVGID_00000048477462083317142730000001647801330545237920_);" points="846.2,342.3 820.6,357.2
					820.6,348.8 846.2,333.9 				"/>

        <linearGradient id="SVGID_00000088101795600016926420000015336370322716171162_" gradientUnits="userSpaceOnUse"
                        x1="820.5844" y1="356.5336" x2="846.2228" y2="356.5336">
					<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
          <stop offset="0.2003" style="stop-color:#237761"/>
          <stop offset="0.4783" style="stop-color:#2D8A70"/>
          <stop offset="0.8012" style="stop-color:#3DA788"/>
          <stop offset="1" style="stop-color:#49BD99"/>
				</linearGradient>
        <polygon style="fill:url(#SVGID_00000088101795600016926420000015336370322716171162_);" points="846.2,353.3 820.6,368.2
					820.6,359.8 846.2,344.9 				"/>

        <linearGradient id="SVGID_00000119819141237363241390000008623485270492968851_" gradientUnits="userSpaceOnUse"
                        x1="820.5844" y1="368.0797" x2="846.2228" y2="368.0797">
					<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
          <stop offset="0.2003" style="stop-color:#237761"/>
          <stop offset="0.4783" style="stop-color:#2D8A70"/>
          <stop offset="0.8012" style="stop-color:#3DA788"/>
          <stop offset="1" style="stop-color:#49BD99"/>
				</linearGradient>
        <polygon style="fill:url(#SVGID_00000119819141237363241390000008623485270492968851_);" points="846.2,364.8 820.6,379.7
					820.6,371.3 846.2,356.4 				"/>
        <polygon class="st717" points="820.6,368.2 813.3,372.4 813.3,364 820.6,359.8 				"/>
			</g>
                  <polygon class="st717" points="820.6,379.7 813.3,383.9 813.3,375.5 820.6,371.3 			"/>
		</g>
                <g>

				<linearGradient id="SVGID_00000042729910379991475140000014022886431057371266_" gradientUnits="userSpaceOnUse"
                        x1="860.9532" y1="333.2441" x2="886.5917" y2="333.2441">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
          <stop offset="0.2003" style="stop-color:#237761"/>
          <stop offset="0.4783" style="stop-color:#2D8A70"/>
          <stop offset="0.8012" style="stop-color:#3DA788"/>
          <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
                  <polygon style="fill:url(#SVGID_00000042729910379991475140000014022886431057371266_);" points="886.6,330 861,344.9 861,336.5
				886.6,321.6 			"/>

                  <linearGradient id="SVGID_00000075149796203401459090000012239521255159946629_"
                                  gradientUnits="userSpaceOnUse" x1="860.9532" y1="344.7902" x2="886.5917"
                                  y2="344.7902">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
                    <stop offset="0.2003" style="stop-color:#237761"/>
                    <stop offset="0.4783" style="stop-color:#2D8A70"/>
                    <stop offset="0.8012" style="stop-color:#3DA788"/>
                    <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
                  <polygon style="fill:url(#SVGID_00000075149796203401459090000012239521255159946629_);" points="886.6,341.5 861,356.4
				861,348.1 886.6,333.1 			"/>

                  <linearGradient id="SVGID_00000164502947712795271730000005096433488742381718_"
                                  gradientUnits="userSpaceOnUse" x1="860.9532" y1="322.2268" x2="886.5917"
                                  y2="322.2268">
				<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
                    <stop offset="0.2003" style="stop-color:#237761"/>
                    <stop offset="0.4783" style="stop-color:#2D8A70"/>
                    <stop offset="0.8012" style="stop-color:#3DA788"/>
                    <stop offset="1" style="stop-color:#49BD99"/>
			</linearGradient>
                  <polygon style="fill:url(#SVGID_00000164502947712795271730000005096433488742381718_);" points="886.6,319 861,333.9 861,325.5
				886.6,310.6 			"/>
                  <polygon class="st717" points="861,333.9 853.7,338.1 853.7,329.7 861,325.5 			"/>
                  <polygon class="st717" points="861,344.9 853.7,349.1 853.7,340.7 861,336.5 			"/>
                  <polygon class="st717" points="861,356.4 853.7,360.6 853.7,352.3 861,348.1 			"/>
		</g>
                <g>
			<g>
				<path class="st757" d="M738.7,468.8c0-30.6-21-43.5-47.2-29.6v-0.1l-2.1,1.2l-2.1,1.2v0.1c-1.1,0.7-2.3,1.5-3.5,2.3
					c-25,17.6-43.8,52.9-43.8,81.9c0,13,3.7,23.1,10.7,29.2c0.6,0.5,1.3,1,1.9,1.5l0,0.1l1.5,0.9c0,0,0,0,0,0l1.5,0.9l0-0.1
					c9.2,4.7,21.1,3.3,33.8-4c3.7-2.1,7.3-4.7,10.9-7.7l0,0.1l2-1.8c0,0,0,0,0,0l2-1.8l0,0C724.7,523.7,738.7,493.6,738.7,468.8z
					 M679.8,513.7c-2.5-1.5-3.8-4.6-3.8-8.6c0-8.6,6-19,13.4-23.3c7.4-4.3,13.4-0.8,13.4,7.8c0,7-4.1,15.5-9.9,20.7
					c-1.2,1.1-2.4,1.9-3.5,2.6C685.8,514.9,682.3,515.2,679.8,513.7z"/>
        <path class="st750" d="M689.4,515.3c-4.4,2.5-8.3,2.7-11.1,1l-22.7,38.7c8.6,5.2,20.5,4.6,33.8-3.1c4.3-2.5,8.5-5.6,12.4-9.1
					l-8.3-30.5C692.2,513.4,690.8,514.4,689.4,515.3z"/>

        <linearGradient id="SVGID_00000154394690675834223160000004569980664002169787_" gradientUnits="userSpaceOnUse"
                        x1="2151.2339" y1="3174.979" x2="2151.2339" y2="3082.1665"
                        gradientTransform="matrix(0.866 -0.5 0 1.1547 -1149.95 -2054.2354)">
					<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
          <stop offset="0.2003" style="stop-color:#237761"/>
          <stop offset="0.4783" style="stop-color:#2D8A70"/>
          <stop offset="0.8012" style="stop-color:#3DA788"/>
          <stop offset="1" style="stop-color:#49BD99"/>
				</linearGradient>
        <path style="fill:url(#SVGID_00000154394690675834223160000004569980664002169787_);" d="M736.6,470c0-30.1-21.1-42.3-47.2-27.3
					v36.6c8.6-5,15.5-0.9,15.5,9c0,8.3-4.9,18-11.5,23.9l8.3,30.5C721.9,524.9,736.6,495.2,736.6,470z"/>
        <path class="st744" d="M684.1,446.2c-23.6,16.7-41.9,50.3-41.9,78.4c0,12.8,3.8,22.4,10.3,28c1,0.9,2.1,1.7,3.2,2.3l22.7-38.7
					c-2.7-1.7-4.4-5.1-4.4-10c0-9.9,7-22,15.5-26.9v-36.6C687.6,443.8,685.8,445,684.1,446.2z"/>
			</g>
                  <g>
				<polygon class="st750" points="735.8,433.8 735.1,433.7 746,407.2 763.2,397.3 763.2,398.2 746.5,407.8 				"/>
			</g>
                  <g>
				<polygon class="st750" points="652.4,472 642,464.5 615.7,479.7 615.7,478.8 642.3,463.4 653,471.1 				"/>
			</g>
                  <g>
				<polygon class="st750" points="756.5,530 678.3,575.2 678.3,565.2 679.1,564.7 679.1,573.8 756.5,529.1 				"/>
			</g>
                  <polygon class="st737" points="763.3,394 732,412.1 732,402 763.3,383.9 			"/>
                  <polygon class="st737" points="647,456.1 615.7,474.2 615.7,464.1 647,446 			"/>
                  <polygon class="st737" points="756.6,525 725.3,543.1 725.3,533 756.6,515 			"/>
		</g>
	</g>
</g>
            <path class="st404" d="M244.3,961.5c5.2-0.1,10.4-0.4,15.4-0.4c5.3,0,10.5,0.2,15.7,0.5c7.5,1.2,12.6,2.2,18.2,7.7
	c3.7,3.5,5.7,7.7,6.4,9.2c3.7,8.3,3.5,15.9,3.3,25c-0.7,8.1-1.1,9.9-3.4,17.7c-0.4,0.9-0.7,1.9-1.2,2.8c-1.4,3.2-4.8,10.7-13.3,15.6
	c-3.5,2-6.4,2.8-14,3.9c-6.4,0.4-12.6,0.7-19.1,0.7c-3.5,0-7.2-0.1-10.7-0.1c-5.4,0-10.8,0-16.3,0.1c0.6-7.1,1.3-14.1,1.7-21.2
	c0.2-5.8,0.4-11.6,0.7-17.3c0.4-8.1,0.8-16.4,1.1-24.6c0.2-6.5,0.2-13,0.4-19.5H244.3z M243.2,1030c5.4,0,11,0.1,16.3-0.2l6-0.4
	c0.4-0.1,3.8-0.6,5.9-1.4c2-0.7,6.4-2.6,9.6-7.5c3.7-5.7,5.7-14.6,5.7-21.2c0-3.5-0.4-17.6-13.1-22.2c-2.9-1.1-5.4-1.2-8.5-1.4
	h-19.3L243.2,1030z"/>
</svg>
        </div>
      </template>
      <span>Dashboard</span>
    </v-tooltip>
  </div>
</template>

<script>
/**
 * @component DashboardButton
 * Home button component that redirects to Dashboard page
 */
export default {
  name: 'DashboardButton',
  props: {
    isMobileOrTablet: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    goToDashboardPage() {
      this.$router.push('/dashboard');
    }
  }
}

</script>

<style lang="scss" scoped>
.main-light {
  .home-button {
    background-color: rgba(0, 0, 0, 0.15);
    border: 4px solid #5c9485;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.7);

    &:hover {
      background-color: rgb(255, 255, 255);
      border: 4px solid #4ABD96 !important;
      box-shadow: 5px 5px 14px rgba(0, 0, 0, 0.7);
      cursor: pointer;
      z-index: 99999;
      transform: scale(1.1);
    }
  }
}
</style>

<style scoped>
.st0 {
  clip-path: url(#SVGID_00000158710379686657296930000016371260592363836834_);
}

.st1 {
  clip-path: url(#SVGID_00000028307893389382901180000010466306972182958772_);
  enable-background: new;
}

.st2 {
  clip-path: url(#SVGID_00000070809620370756848760000016764712875538287545_);
}

.st3 {
  clip-path: url(#SVGID_00000147922422034261768330000007133156282866536847_);
}

.st4 {
  opacity: 0;
  clip-path: url(#SVGID_00000109748836177073501420000012798868713848722099_);
}

.st5 {
  opacity: 0;
}

.st6 {
  clip-path: url(#SVGID_00000098216905633652510510000006421186438136091284_);
}

.st7 {
  clip-path: url(#SVGID_00000021100393998275208580000016264201699713516985_);
}

.st8 {
  clip-path: url(#SVGID_00000062178667203255701320000009182020828936188838_);
  fill: #3FB994;
}

.st9 {
  clip-path: url(#SVGID_00000116230489840528375940000012655318312300823700_);
}

.st10 {
  clip-path: url(#SVGID_00000176004016674099006180000013724892888286982275_);
  enable-background: new;
}

.st11 {
  clip-path: url(#SVGID_00000144336633542392675590000002077056214580732841_);
}

.st12 {
  clip-path: url(#SVGID_00000155830097895338128060000006310001050404133257_);
}

.st13 {
  clip-path: url(#SVGID_00000025401052067252354990000011733767730771111305_);
  fill: #3FB994;
}

.st14 {
  clip-path: url(#SVGID_00000026152771911123618970000001323356289880354453_);
}

.st15 {
  clip-path: url(#SVGID_00000144319771099153645460000013068106768283447695_);
}

.st16 {
  clip-path: url(#SVGID_00000101074793018858890900000017083703352675191196_);
  fill: #3FB994;
}

.st17 {
  clip-path: url(#SVGID_00000170964512745251030020000004106140753728440736_);
}

.st18 {
  clip-path: url(#SVGID_00000091697927439999953670000004483514172542160518_);
}

.st19 {
  clip-path: url(#SVGID_00000094592450003558444210000003859672506057631383_);
  fill: #3FB994;
}

.st20 {
  clip-path: url(#SVGID_00000179618205681409551340000014531488890459265202_);
}

.st21 {
  clip-path: url(#SVGID_00000049921731576534355870000018120310634998157972_);
}

.st22 {
  clip-path: url(#SVGID_00000143610281546357678700000015037422335399941301_);
  fill: #3FB994;
}

.st23 {
  clip-path: url(#SVGID_00000083790941973047025750000010262750351006574753_);
}

.st24 {
  clip-path: url(#SVGID_00000150095906691818062790000008283133131394537882_);
}

.st25 {
  clip-path: url(#SVGID_00000109723017811746085840000000490963458267445923_);
  fill: #3FB994;
}

.st26 {
  clip-path: url(#SVGID_00000063613473016968603430000018210713196020420532_);
}

.st27 {
  clip-path: url(#SVGID_00000047023936548870013550000016320380628479190679_);
}

.st28 {
  clip-path: url(#SVGID_00000084515777843916130730000000997058930708191149_);
  fill: #3FB994;
}

.st29 {
  clip-path: url(#SVGID_00000182518101181680592360000015184472720174716586_);
}

.st30 {
  clip-path: url(#SVGID_00000039132909205254002890000012172417481962043562_);
}

.st31 {
  clip-path: url(#SVGID_00000000202058028149980080000006701367135009030307_);
  fill: #3FB994;
}

.st32 {
  clip-path: url(#SVGID_00000130634772255646207750000017545348597299229843_);
}

.st33 {
  clip-path: url(#SVGID_00000004508918024735437710000001874914039420369577_);
}

.st34 {
  clip-path: url(#SVGID_00000094602641349692172260000003195847917705078700_);
  fill: #3FB994;
}

.st35 {
  clip-path: url(#SVGID_00000067949562678961373950000011332219438903795340_);
}

.st36 {
  clip-path: url(#SVGID_00000051346215546826926380000006495582640695809167_);
}

.st37 {
  clip-path: url(#SVGID_00000141457313753223358950000016981993931663804288_);
  fill: #3FB994;
}

.st38 {
  clip-path: url(#SVGID_00000028291881121635686880000009723904460544532627_);
}

.st39 {
  clip-path: url(#SVGID_00000150786771769498977490000013760783238243935896_);
}

.st40 {
  clip-path: url(#SVGID_00000014614681045968691640000009738491112264322229_);
  fill: #3FB994;
}

.st41 {
  clip-path: url(#SVGID_00000146460452984407686590000009958502726549675924_);
}

.st42 {
  clip-path: url(#SVGID_00000115515858489602197960000015060814839727508643_);
}

.st43 {
  clip-path: url(#SVGID_00000140711237477280946780000017347920566943040130_);
  fill: #3FB994;
}

.st44 {
  clip-path: url(#SVGID_00000054978908732714922010000008878974877841794198_);
}

.st45 {
  clip-path: url(#SVGID_00000013909821715867676950000012513699802937729930_);
}

.st46 {
  clip-path: url(#SVGID_00000100378012373821309040000015000755224988213658_);
  fill: #3FB994;
}

.st47 {
  clip-path: url(#SVGID_00000104707134441212356680000014240494823308716701_);
}

.st48 {
  clip-path: url(#SVGID_00000096777445832554713000000006918090730652302989_);
}

.st49 {
  clip-path: url(#SVGID_00000149340846563232789350000009982970338315047590_);
  fill: #3FB994;
}

.st50 {
  clip-path: url(#SVGID_00000029740578293859884020000017854032668586993085_);
}

.st51 {
  clip-path: url(#SVGID_00000039833122713692414670000009631835657997087931_);
  enable-background: new;
}

.st52 {
  clip-path: url(#SVGID_00000055695737850025691500000012338256716961727926_);
}

.st53 {
  clip-path: url(#SVGID_00000039092470754681952920000017272949309553396390_);
}

.st54 {
  clip-path: url(#SVGID_00000083086178747779031450000003926374775377620139_);
  fill: #306175;
}

.st55 {
  clip-path: url(#SVGID_00000079457093696769852690000004745397385747839137_);
}

.st56 {
  clip-path: url(#SVGID_00000081646774936420495420000003707396042165356425_);
}

.st57 {
  clip-path: url(#SVGID_00000114035393885853904310000002696903080065064106_);
  fill: #32657A;
}

.st58 {
  clip-path: url(#SVGID_00000107573255113247140670000007523214363450328507_);
}

.st59 {
  clip-path: url(#SVGID_00000118373687930405712170000003658597121510759572_);
}

.st60 {
  clip-path: url(#SVGID_00000051352131110966280180000005303962632924648078_);
  fill: #34697F;
}

.st61 {
  clip-path: url(#SVGID_00000176021502679843876570000006406987057957974446_);
}

.st62 {
  clip-path: url(#SVGID_00000171698276882723064220000004666567131618238636_);
}

.st63 {
  clip-path: url(#SVGID_00000171686833704396258630000004374983628879490952_);
  fill: #366C82;
}

.st64 {
  clip-path: url(#SVGID_00000139254034330961247820000008540505345362873004_);
}

.st65 {
  clip-path: url(#SVGID_00000065794981984957325000000002918720164417232805_);
  enable-background: new;
}

.st66 {
  clip-path: url(#SVGID_00000153666301352838751730000012370143427779804564_);
}

.st67 {
  clip-path: url(#SVGID_00000160148341459670899090000017661807361488976798_);
}

.st68 {
  opacity: 0;
  clip-path: url(#SVGID_00000017506711479096732120000014972069130233906088_);
}

.st69 {
  clip-path: url(#SVGID_00000159447363472797650350000012058900776577175714_);
}

.st70 {
  clip-path: url(#SVGID_00000054984168688241663340000004328395688363230362_);
}

.st71 {
  clip-path: url(#SVGID_00000058563885657341539100000003204780361719518903_);
  fill: #3FB994;
}

.st72 {
  clip-path: url(#SVGID_00000004508572632617382870000015556981743090832033_);
}

.st73 {
  clip-path: url(#SVGID_00000150085218046889993520000015795730906698533789_);
  enable-background: new;
}

.st74 {
  clip-path: url(#SVGID_00000069376309963726300210000007461246814388694186_);
}

.st75 {
  clip-path: url(#SVGID_00000078737388466282505510000011256726887748582570_);
}

.st76 {
  clip-path: url(#SVGID_00000009562411201551443930000000547623582680336019_);
  fill: #3FB994;
}

.st77 {
  clip-path: url(#SVGID_00000096059695327186217220000013891395523342773147_);
}

.st78 {
  clip-path: url(#SVGID_00000031198681654334450080000007213499813671324580_);
}

.st79 {
  clip-path: url(#SVGID_00000027576451835996500750000010960138815484603065_);
  fill: #3FB994;
}

.st80 {
  clip-path: url(#SVGID_00000101809197970667341220000004773242100348464830_);
}

.st81 {
  clip-path: url(#SVGID_00000162329341433877514890000007135983288296715192_);
}

.st82 {
  clip-path: url(#SVGID_00000170964437054880824460000003893339681736039611_);
  fill: #3FB994;
}

.st83 {
  clip-path: url(#SVGID_00000126313685404838035250000005042432239859568789_);
}

.st84 {
  clip-path: url(#SVGID_00000077322591100825193110000014353658671821226673_);
}

.st85 {
  clip-path: url(#SVGID_00000152950222831604391100000008154149324160704443_);
  fill: #3FB994;
}

.st86 {
  clip-path: url(#SVGID_00000073704221069914640270000014221034635284580533_);
}

.st87 {
  clip-path: url(#SVGID_00000161596430902747761790000011781269561519097222_);
}

.st88 {
  clip-path: url(#SVGID_00000113348597579639731350000008898676044549309070_);
  fill: #3FB994;
}

.st89 {
  clip-path: url(#SVGID_00000106828786938236647990000008917989813744755120_);
}

.st90 {
  clip-path: url(#SVGID_00000059278426477030800010000009606639005290521986_);
}

.st91 {
  clip-path: url(#SVGID_00000046336087269314240280000013947980328484214423_);
  fill: #3FB994;
}

.st92 {
  clip-path: url(#SVGID_00000114060669603775829930000014024181683562073218_);
}

.st93 {
  clip-path: url(#SVGID_00000017508040229561824450000004199999578933585543_);
}

.st94 {
  clip-path: url(#SVGID_00000002368848033661505690000014455174799769018549_);
  fill: #3FB994;
}

.st95 {
  clip-path: url(#SVGID_00000145743428162694354630000015331304148979539855_);
}

.st96 {
  clip-path: url(#SVGID_00000161598879796635124080000013902009160818382001_);
}

.st97 {
  clip-path: url(#SVGID_00000000944234056255408550000002211578468657934767_);
  fill: #3FB994;
}

.st98 {
  clip-path: url(#SVGID_00000133492124993912302150000006369862895664700302_);
}

.st99 {
  clip-path: url(#SVGID_00000044871472996942100330000017610931369054279062_);
}

.st100 {
  clip-path: url(#SVGID_00000068671221367550015230000009630574256340129158_);
  fill: #3FB994;
}

.st101 {
  clip-path: url(#SVGID_00000000196490881283574560000010365442092400947855_);
}

.st102 {
  clip-path: url(#SVGID_00000083804381047228980360000003929946704066766252_);
}

.st103 {
  clip-path: url(#SVGID_00000042018190685365494320000017430306184494851486_);
  fill: #3FB994;
}

.st104 {
  clip-path: url(#SVGID_00000037685818862667485170000017559424176936696230_);
}

.st105 {
  clip-path: url(#SVGID_00000010274403351486622250000017545372274008648835_);
}

.st106 {
  clip-path: url(#SVGID_00000171709758307626599830000017014494407675755442_);
  fill: #3FB994;
}

.st107 {
  clip-path: url(#SVGID_00000063613909536315346860000005525690241166706818_);
}

.st108 {
  clip-path: url(#SVGID_00000169526954332998425410000012122051916855251110_);
}

.st109 {
  clip-path: url(#SVGID_00000083061461161177053570000001537860029198723969_);
  fill: #3FB994;
}

.st110 {
  clip-path: url(#SVGID_00000176026401305749604410000002985951753476989357_);
}

.st111 {
  clip-path: url(#SVGID_00000062888480244624270840000011065088269614903695_);
}

.st112 {
  clip-path: url(#SVGID_00000124842774486592498900000001815805960622956449_);
  fill: #3FB994;
}

.st113 {
  clip-path: url(#SVGID_00000031173212650437283800000014223724718993859750_);
}

.st114 {
  clip-path: url(#SVGID_00000122684477588877636080000012518297482198801063_);
}

.st115 {
  clip-path: url(#SVGID_00000072242946577764258310000005603419459981987260_);
  fill: #3FB994;
}

.st116 {
  clip-path: url(#SVGID_00000017477611431482211150000015281836407280265891_);
}

.st117 {
  clip-path: url(#SVGID_00000124847192570206336790000009769647990618217905_);
}

.st118 {
  clip-path: url(#SVGID_00000165945648778364477390000014677273211663926422_);
  fill: #3FB994;
}

.st119 {
  clip-path: url(#SVGID_00000161625315647811546880000014990318018533630080_);
}

.st120 {
  clip-path: url(#SVGID_00000023278081099745627440000006755200177855151753_);
}

.st121 {
  clip-path: url(#SVGID_00000083075646376728371270000004470502468528208798_);
  fill: #3FB994;
}

.st122 {
  clip-path: url(#SVGID_00000095311992111016406520000007271742009083878291_);
}

.st123 {
  clip-path: url(#SVGID_00000114759120988116278820000014585186028622025143_);
}

.st124 {
  clip-path: url(#SVGID_00000043446935414396254520000000472669015259368123_);
  fill: #3FB994;
}

.st125 {
  clip-path: url(#SVGID_00000026843354792770549050000002208477879432560826_);
}

.st126 {
  clip-path: url(#SVGID_00000100371451203103476550000011897961576693151896_);
}

.st127 {
  clip-path: url(#SVGID_00000146475268054017881070000006105428866752235175_);
  fill: #3FB994;
}

.st128 {
  clip-path: url(#SVGID_00000080899197506632666400000001376638825264474247_);
}

.st129 {
  clip-path: url(#SVGID_00000040576963907089631260000011519020857611930000_);
  fill: #154C3D;
}

.st130 {
  clip-path: url(#SVGID_00000173878535233182054090000003066022428197329049_);
}

.st131 {
  clip-path: url(#SVGID_00000167373125591207573190000012301835331882550409_);
  fill: #226A57;
}

.st132 {
  clip-path: url(#SVGID_00000041269444536092395380000006605968201793206156_);
}

.st133 {
  clip-path: url(#SVGID_00000025409922295589967380000018071401447792887430_);
  fill: #226A57;
}

.st134 {
  clip-path: url(#SVGID_00000150063216482751655300000004460786109814175144_);
}

.st135 {
  clip-path: url(#SVGID_00000153700867011034587150000000585328351343177860_);
  fill: #3FB994;
}

.st136 {
  clip-path: url(#SVGID_00000062186903702048270930000015223577635467976321_);
}

.st137 {
  clip-path: url(#SVGID_00000047036703761084156670000002205923351463186049_);
  fill: #3FB994;
}

.st138 {
  clip-path: url(#SVGID_00000160881036069153409630000005164977008421308334_);
}

.st139 {
  clip-path: url(#SVGID_00000029043069721948076670000009049337130340517823_);
  fill: #25292A;
}

.st140 {
  clip-path: url(#SVGID_00000078735379659412887410000009053420621313245317_);
}

.st141 {
  clip-path: url(#SVGID_00000044883963999114700150000009909791457263417010_);
  fill: #3FB994;
}

.st142 {
  clip-path: url(#SVGID_00000046323808434847193630000015766523702733920157_);
}

.st143 {
  clip-path: url(#SVGID_00000041260676460046038390000010754535812681737649_);
  fill: #42B994;
}

.st144 {
  clip-path: url(#SVGID_00000133493634407008267970000008708900759353719737_);
}

.st145 {
  clip-path: url(#SVGID_00000137851285881542353670000013055334739961516703_);
  fill: #25292A;
}

.st146 {
  clip-path: url(#SVGID_00000137096357420947001360000009310137438855505312_);
}

.st147 {
  clip-path: url(#SVGID_00000062912854754619858300000010392376636475526275_);
  fill: #42B994;
}

.st148 {
  clip-path: url(#SVGID_00000144329925324741699070000008088695471585722812_);
}

.st149 {
  clip-path: url(#SVGID_00000035503979081823421600000003279040760747342726_);
  fill: #25292A;
}

.st150 {
  clip-path: url(#SVGID_00000024704459128713834280000013819711199406894995_);
}

.st151 {
  clip-path: url(#SVGID_00000165194443603200956830000011171873064269450674_);
  fill: #42B994;
}

.st152 {
  clip-path: url(#SVGID_00000080178624102286545480000014858795373563191973_);
}

.st153 {
  clip-path: url(#SVGID_00000147914899763020583300000017822206682542752410_);
  fill: #25292A;
}

.st154 {
  clip-path: url(#SVGID_00000103980425729464431380000006905038584235205771_);
}

.st155 {
  clip-path: url(#SVGID_00000171707216509505035700000008502179205536448672_);
  enable-background: new;
}

.st156 {
  clip-path: url(#SVGID_00000054267071281883733030000012984263017791962509_);
}

.st157 {
  clip-path: url(#SVGID_00000018229835458155636460000003940440068291845304_);
}

.st158 {
  clip-path: url(#SVGID_00000018204760240916716590000017322969368514184077_);
  fill: #25292A;
}

.st159 {
  clip-path: url(#SVGID_00000088097088923913275530000010426548870701175940_);
}

.st160 {
  clip-path: url(#SVGID_00000130611338086073635500000013320374980312813708_);
}

.st161 {
  clip-path: url(#SVGID_00000116212434001748301920000002604170717556478081_);
  fill: #25292A;
}

.st162 {
  clip-path: url(#SVGID_00000016773207402655042090000003240674942624398230_);
}

.st163 {
  clip-path: url(#SVGID_00000145764075607418052540000000116530490535626941_);
  enable-background: new;
}

.st164 {
  clip-path: url(#SVGID_00000047050164235802037410000012660402297514195075_);
}

.st165 {
  clip-path: url(#SVGID_00000057832137861824799040000016149226645741185957_);
}

.st166 {
  clip-path: url(#SVGID_00000121257368010047822770000009290688182194594740_);
  fill: #3FB994;
}

.st167 {
  clip-path: url(#SVGID_00000040552163134970394170000005330118591474153350_);
}

.st168 {
  clip-path: url(#SVGID_00000022543107065331848180000016356216540558929596_);
}

.st169 {
  clip-path: url(#SVGID_00000149361131898930776140000007935432101491433344_);
  fill: #001820;
}

.st170 {
  clip-path: url(#SVGID_00000046316627306876133400000012167447625431537850_);
}

.st171 {
  clip-path: url(#SVGID_00000099628475434252703070000005168270033691994265_);
  fill: #25292A;
}

.st172 {
  clip-path: url(#SVGID_00000062185679015877930690000005362313823668058247_);
}

.st173 {
  clip-path: url(#SVGID_00000087377631852179886610000009129315122781288582_);
  fill: #25292A;
}

.st174 {
  clip-path: url(#SVGID_00000075866857471794005350000014367009107992861589_);
}

.st175 {
  clip-path: url(#SVGID_00000116951433523276873830000008575505162900469156_);
  fill: #A4A6A5;
}

.st176 {
  clip-path: url(#SVGID_00000183937900901280059970000003270397897115533215_);
}

.st177 {
  clip-path: url(#SVGID_00000112630324656383866390000011250809831452423574_);
  fill: #9CB3C6;
}

.st178 {
  clip-path: url(#SVGID_00000060006532522571559200000013777539721021305515_);
}

.st179 {
  clip-path: url(#SVGID_00000125574708882866630620000001937614589658955196_);
  fill: #9CB3C6;
}

.st180 {
  clip-path: url(#SVGID_00000034090464720968292010000014609409004799057317_);
}

.st181 {
  clip-path: url(#SVGID_00000182519617479007599350000014579992643696714425_);
  fill: #25292A;
}

.st182 {
  clip-path: url(#SVGID_00000026164154078730962850000010201825695611025343_);
}

.st183 {
  clip-path: url(#SVGID_00000112594300089650270660000004617027282918891448_);
  fill: #E0E1DB;
}

.st184 {
  clip-path: url(#SVGID_00000004529925495889384450000006585403495520065469_);
}

.st185 {
  clip-path: url(#SVGID_00000107563786340018468340000005731157535898031537_);
  fill: #25292A;
}

.st186 {
  clip-path: url(#SVGID_00000045611899424146895730000010630955774477073330_);
}

.st187 {
  clip-path: url(#SVGID_00000048463343047468781690000014825743104324920195_);
  fill: #25292A;
}

.st188 {
  clip-path: url(#SVGID_00000016787426869070097370000017234688851836140202_);
}

.st189 {
  clip-path: url(#SVGID_00000103974589375202250270000017672013432036270978_);
  fill: #25292A;
}

.st190 {
  clip-path: url(#SVGID_00000019668433431769119460000011263315484320160666_);
}

.st191 {
  clip-path: url(#SVGID_00000060025992006642103520000010852949969969760155_);
  fill: #A4A6A5;
}

.st192 {
  clip-path: url(#SVGID_00000114759888661151247980000008342423271369369275_);
}

.st193 {
  clip-path: url(#SVGID_00000084526348817256702210000006008479391117074081_);
  enable-background: new;
}

.st194 {
  clip-path: url(#SVGID_00000155846030032300726640000006100548594564593076_);
}

.st195 {
  clip-path: url(#SVGID_00000038390365940233618310000018035870907292132003_);
}

.st196 {
  opacity: 0;
  clip-path: url(#SVGID_00000157995790389002828490000018276437865923552184_);
}

.st197 {
  clip-path: url(#SVGID_00000011748743152240629870000003025678065946739362_);
}

.st198 {
  clip-path: url(#SVGID_00000101063260944654290880000000337983914111240109_);
}

.st199 {
  clip-path: url(#SVGID_00000039814967324039041500000001397890185338515631_);
  enable-background: new;
}

.st200 {
  clip-path: url(#SVGID_00000132799915449379528920000003584670378769555878_);
}

.st201 {
  clip-path: url(#SVGID_00000107590591587060864240000015620515050281189040_);
}

.st202 {
  opacity: 0;
  clip-path: url(#SVGID_00000080164446351131370940000014237445378769293992_);
}

.st203 {
  clip-path: url(#SVGID_00000119815297818931370520000013070090296756048043_);
}

.st204 {
  clip-path: url(#SVGID_00000041296386629661438300000005518565727941203127_);
}

.st205 {
  clip-path: url(#SVGID_00000128482849625773549120000006014738840985063847_);
  enable-background: new;
}

.st206 {
  clip-path: url(#SVGID_00000024697841553455771260000005722759607193119112_);
}

.st207 {
  clip-path: url(#SVGID_00000096744399623602106240000004687510448347412120_);
}

.st208 {
  opacity: 0;
  clip-path: url(#SVGID_00000008139029311484075790000006983477247496161417_);
}

.st209 {
  clip-path: url(#SVGID_00000099619641317569097080000014934335232133840542_);
}

.st210 {
  clip-path: url(#SVGID_00000114765559693431130970000010871520630544135084_);
}

.st211 {
  clip-path: url(#SVGID_00000029030940750836886470000001643970619204667264_);
  fill: #4EBD99;
}

.st212 {
  clip-path: url(#SVGID_00000101101831837189912220000009593627625448052125_);
}

.st213 {
  clip-path: url(#SVGID_00000116944176442972109680000008781166479414964866_);
  fill: #42B994;
}

.st214 {
  clip-path: url(#SVGID_00000022552014285663366010000000246953938249160080_);
}

.st215 {
  clip-path: url(#SVGID_00000159430964387275918830000008844225628067925688_);
  fill: #226A57;
}

.st216 {
  clip-path: url(#SVGID_00000080905481355727751080000010264623138157554054_);
}

.st217 {
  clip-path: url(#SVGID_00000013186654507030481120000004185726013053796005_);
  fill: #165748;
}

.st218 {
  clip-path: url(#SVGID_00000081645896298875666470000006789072717850886063_);
}

.st219 {
  clip-path: url(#SVGID_00000172427451719691762710000014003506738536198788_);
  fill: #42B994;
}

.st220 {
  clip-path: url(#SVGID_00000061470270929443780820000002781896917177011376_);
}

.st221 {
  clip-path: url(#SVGID_00000100362787774448373010000011989684270009135512_);
  fill: #226A57;
}

.st222 {
  clip-path: url(#SVGID_00000114047211987110628830000001723753670357586343_);
}

.st223 {
  clip-path: url(#SVGID_00000164488938189532239780000000879248073465483419_);
  fill: #165748;
}

.st224 {
  clip-path: url(#SVGID_00000154416029375138767550000000211646491990844337_);
}

.st225 {
  clip-path: url(#SVGID_00000042702506355088548890000018270377941161984920_);
  fill: #42B994;
}

.st226 {
  clip-path: url(#SVGID_00000111154656315983314260000014090201650962667702_);
}

.st227 {
  clip-path: url(#SVGID_00000028300511784531357810000006167756982858724752_);
  fill: #226A57;
}

.st228 {
  clip-path: url(#SVGID_00000026132569421137373720000006988616081469306498_);
}

.st229 {
  clip-path: url(#SVGID_00000067196138415802973470000001692427853600538512_);
  fill: #165748;
}

.st230 {
  clip-path: url(#SVGID_00000069375318271994052180000010248574288856727952_);
}

.st231 {
  clip-path: url(#SVGID_00000124850423996822412030000016468619944146661769_);
  fill: #42B994;
}

.st232 {
  clip-path: url(#SVGID_00000037693143540869260580000016403718586866574500_);
}

.st233 {
  clip-path: url(#SVGID_00000031189719273858755630000016112204045005592195_);
  fill: #226A57;
}

.st234 {
  clip-path: url(#SVGID_00000163049272881525795900000012107814030361881501_);
}

.st235 {
  clip-path: url(#SVGID_00000163060378907781659350000014701014939157559719_);
  fill: #165748;
}

.st236 {
  clip-path: url(#SVGID_00000090266046101641253600000016826745067895174038_);
}

.st237 {
  clip-path: url(#SVGID_00000109739986006970694760000002920877954617686425_);
  fill: #42B994;
}

.st238 {
  clip-path: url(#SVGID_00000142146671135991502010000004067241055432445610_);
}

.st239 {
  clip-path: url(#SVGID_00000018936464970262855500000011905014395233860504_);
  fill: #226A57;
}

.st240 {
  clip-path: url(#SVGID_00000005253978169596858230000016502080160496355754_);
}

.st241 {
  clip-path: url(#SVGID_00000018204969476593416550000017999184754162323128_);
  fill: #165748;
}

.st242 {
  clip-path: url(#SVGID_00000015340849239860102890000009082373042310723510_);
}

.st243 {
  clip-path: url(#SVGID_00000116199925661483358680000008708161656440262584_);
  fill: #226A57;
}

.st244 {
  clip-path: url(#SVGID_00000057860134472646320500000011146860248156098746_);
}

.st245 {
  clip-path: url(#SVGID_00000065786577885939498790000004937938876966232727_);
  fill: #FFFFFF;
}

.st246 {
  clip-path: url(#SVGID_00000004527506674556568000000015195750699307596198_);
}

.st247 {
  clip-path: url(#SVGID_00000116230000105625067410000008192821421544864181_);
  fill: #226A57;
}

.st248 {
  clip-path: url(#SVGID_00000177470618370209958650000017925244719971736509_);
}

.st249 {
  clip-path: url(#SVGID_00000106843335328348709420000010837555313884264382_);
  fill: #42B994;
}

.st250 {
  clip-path: url(#SVGID_00000008111589686102307830000016068750218671279748_);
}

.st251 {
  clip-path: url(#SVGID_00000043446141426995251960000013050950033234434463_);
  fill: #226A57;
}

.st252 {
  clip-path: url(#SVGID_00000119806313444521623860000006751829144382722997_);
}

.st253 {
  clip-path: url(#SVGID_00000083085214771264642220000011981555723631548047_);
  fill: #42B994;
}

.st254 {
  clip-path: url(#SVGID_00000088106255803687535010000017796647491078928257_);
}

.st255 {
  clip-path: url(#SVGID_00000161628275394263757310000012138154328837405589_);
  fill: #226A57;
}

.st256 {
  clip-path: url(#SVGID_00000121277069684848697030000007340284119983257266_);
}

.st257 {
  clip-path: url(#SVGID_00000140694525022064784870000010133718912097500863_);
  fill: #42B994;
}

.st258 {
  clip-path: url(#SVGID_00000073691216405183703120000017249035588108629408_);
}

.st259 {
  clip-path: url(#SVGID_00000090977134666305637020000013314785954412701117_);
  fill: #EBEAE6;
}

.st260 {
  clip-path: url(#SVGID_00000078023156370731158330000005112195017997068426_);
}

.st261 {
  clip-path: url(#SVGID_00000124869483211390360210000009439086660771420567_);
  fill: #DCDDD7;
}

.st262 {
  clip-path: url(#SVGID_00000050632726203977805330000017156826952908405893_);
}

.st263 {
  clip-path: url(#SVGID_00000098216731057669379570000009032605189881009289_);
  fill: #868B89;
}

.st264 {
  clip-path: url(#SVGID_00000127729234664258062440000015323593079988029365_);
}

.st265 {
  clip-path: url(#SVGID_00000165912825499723225780000013789152660772541074_);
  fill: #95CCB9;
}

.st266 {
  clip-path: url(#SVGID_00000159465685063654300550000013139592290350691237_);
}

.st267 {
  clip-path: url(#SVGID_00000142164444174462765830000000542690403280503714_);
  fill: #82A79C;
}

.st268 {
  clip-path: url(#SVGID_00000111188992257140363550000014804497765433790617_);
}

.st269 {
  clip-path: url(#SVGID_00000016757044859974523450000006382176685541604030_);
  fill: #7FA096;
}

.st270 {
  clip-path: url(#SVGID_00000012470462184821301750000003763083393902981046_);
}

.st271 {
  clip-path: url(#SVGID_00000174586078891384095240000013036220373579924133_);
  fill: #95CCB9;
}

.st272 {
  clip-path: url(#SVGID_00000100349783974658802720000012590513851945590948_);
}

.st273 {
  clip-path: url(#SVGID_00000158736724203240683810000005684209606510859149_);
  fill: #82A79C;
}

.st274 {
  clip-path: url(#SVGID_00000026132379060121850070000003879182219290668930_);
}

.st275 {
  clip-path: url(#SVGID_00000170992027099599007180000007319360741361155971_);
  fill: #7FA096;
}

.st276 {
  clip-path: url(#SVGID_00000049193323552896184530000013296339414425041590_);
}

.st277 {
  clip-path: url(#SVGID_00000088824472499558551290000008212304913878149303_);
  fill: #95CCB9;
}

.st278 {
  clip-path: url(#SVGID_00000106844253111629551430000001167444753893524873_);
}

.st279 {
  clip-path: url(#SVGID_00000090296882720416313340000001355492560789786045_);
  fill: #82A79C;
}

.st280 {
  clip-path: url(#SVGID_00000122717609924697996270000016961736214277555867_);
}

.st281 {
  clip-path: url(#SVGID_00000076564692644627272070000003196122320555999156_);
  fill: #95CCB9;
}

.st282 {
  clip-path: url(#SVGID_00000030445104166514261840000002637302936833850758_);
}

.st283 {
  clip-path: url(#SVGID_00000152247232319689566480000012680558537658892452_);
  fill: #82A79C;
}

.st284 {
  clip-path: url(#SVGID_00000077301253415331915780000004308261296705660813_);
}

.st285 {
  clip-path: url(#SVGID_00000173873749668226504680000018403473343947223428_);
  fill: #7FA096;
}

.st286 {
  clip-path: url(#SVGID_00000109729880317143450180000012715133712370543254_);
}

.st287 {
  clip-path: url(#SVGID_00000134960132201784293900000005629684759541672366_);
  fill: #95CCB9;
}

.st288 {
  clip-path: url(#SVGID_00000029024082061020237950000000647248172828962711_);
}

.st289 {
  clip-path: url(#SVGID_00000070817563792963948280000015188477330769898937_);
  fill: #7FA096;
}

.st290 {
  clip-path: url(#SVGID_00000164491195387123623390000005649034914948213406_);
}

.st291 {
  clip-path: url(#SVGID_00000088102637765516183180000018390640961994169275_);
  fill: #82A79C;
}

.st292 {
  clip-path: url(#SVGID_00000178176154424799117610000005479876637173711031_);
}

.st293 {
  clip-path: url(#SVGID_00000119116703845045932720000008695318279226583470_);
  fill: #EBEBE7;
}

.st294 {
  clip-path: url(#SVGID_00000126308428126182089980000005077613359818565817_);
}

.st295 {
  clip-path: url(#SVGID_00000164510211525749702940000001490636431147573638_);
  fill: #999A98;
}

.st296 {
  clip-path: url(#SVGID_00000116935416194930006630000018145244413124944300_);
}

.st297 {
  clip-path: url(#SVGID_00000176726399158082119670000014926479719464097726_);
  fill: #999A98;
}

.st298 {
  clip-path: url(#SVGID_00000079484055671458133800000011578363723053310593_);
}

.st299 {
  clip-path: url(#SVGID_00000114788003170486385330000014122286688033381259_);
  fill: #6B59A6;
}

.st300 {
  clip-path: url(#SVGID_00000043425239213119301460000006771580133141668251_);
}

.st301 {
  clip-path: url(#SVGID_00000048493004839756122270000002385687003708191386_);
  fill: #6B59A6;
}

.st302 {
  clip-path: url(#SVGID_00000060025075532984619580000012933824467003832998_);
}

.st303 {
  clip-path: url(#SVGID_00000174597410898594519120000011029505321146276287_);
  fill: #548D7A;
}

.st304 {
  clip-path: url(#SVGID_00000110447090094101944790000015270344424758830505_);
}

.st305 {
  clip-path: url(#SVGID_00000026883960837482995390000003857451918383817610_);
  fill: #4D8271;
}

.st306 {
  clip-path: url(#SVGID_00000046316718651300232260000011753522912952783774_);
}

.st307 {
  clip-path: url(#SVGID_00000094604583329378234870000003369449781652447908_);
  fill: #4A7F6F;
}

.st308 {
  clip-path: url(#SVGID_00000070837997140953814690000003682345460127015838_);
}

.st309 {
  clip-path: url(#SVGID_00000152263552226857014340000018226509591740941698_);
  fill: #4D8271;
}

.st310 {
  clip-path: url(#SVGID_00000169541730071786950220000000145885492559974328_);
}

.st311 {
  clip-path: url(#SVGID_00000018958750048355151420000009387313136636581031_);
  fill: #699687;
}

.st312 {
  clip-path: url(#SVGID_00000092449123062807834290000011664630825603252117_);
}

.st313 {
  clip-path: url(#SVGID_00000080919544763504790880000011102465596510782124_);
  fill: #C9DAD1;
}

.st314 {
  clip-path: url(#SVGID_00000020389301581264050100000008813461411220053149_);
}

.st315 {
  clip-path: url(#SVGID_00000051378759105234734350000016464231437069665443_);
  fill: #C9DAD1;
}

.st316 {
  clip-path: url(#SVGID_00000133528389322275493220000006485023461662882974_);
}

.st317 {
  clip-path: url(#SVGID_00000068641916079543038120000006387798319120133310_);
  fill: #C9DAD1;
}

.st318 {
  clip-path: url(#SVGID_00000012453048251148940530000007961133316549496993_);
}

.st319 {
  clip-path: url(#SVGID_00000157996219624017483260000004773225193980746131_);
  fill: #165748;
}

.st320 {
  clip-path: url(#SVGID_00000061453403156834807790000012390426786894935468_);
}

.st321 {
  clip-path: url(#SVGID_00000095327794058378299280000008374488558984108459_);
  fill: #165748;
}

.st322 {
  clip-path: url(#SVGID_00000021117744627422132940000010048591487647350970_);
}

.st323 {
  clip-path: url(#SVGID_00000109018944623224440640000001259880946169173650_);
  fill: #165748;
}

.st324 {
  clip-path: url(#SVGID_00000064314746795266805630000008486587244267967620_);
}

.st325 {
  clip-path: url(#SVGID_00000035518879130667339150000014738732203275679920_);
  fill: #165748;
}

.st326 {
  clip-path: url(#SVGID_00000155866622607655036210000009110097576521377956_);
}

.st327 {
  clip-path: url(#SVGID_00000020366711880925758240000014289012656104626351_);
  fill: #A4B6AD;
}

.st328 {
  clip-path: url(#SVGID_00000070804414565450725960000013653058353913595047_);
}

.st329 {
  clip-path: url(#SVGID_00000179635455135380808410000004535914323985179824_);
  fill: #A2B3AB;
}

.st330 {
  clip-path: url(#SVGID_00000127004683908314196180000012286367301184696198_);
}

.st331 {
  clip-path: url(#SVGID_00000038394689824126908470000009596688257688966827_);
  fill: #91B1A5;
}

.st332 {
  clip-path: url(#SVGID_00000024697661270695582820000011710577935022238371_);
}

.st333 {
  clip-path: url(#SVGID_00000039838223807557099530000014265687267501329291_);
  fill: #8BA79D;
}

.st334 {
  clip-path: url(#SVGID_00000085970239059692191560000002825985751598496401_);
}

.st335 {
  clip-path: url(#SVGID_00000165919623403116761110000007131908086791693479_);
  fill: #91B1A5;
}

.st336 {
  clip-path: url(#SVGID_00000059297060658555817660000000267188869018838689_);
}

.st337 {
  clip-path: url(#SVGID_00000102517883721238432830000011581272276730361251_);
  fill: #8BA79D;
}

.st338 {
  clip-path: url(#SVGID_00000085220792002316019570000012899496114103477412_);
}

.st339 {
  clip-path: url(#SVGID_00000104701166685188349610000003236993397393089213_);
  fill: #6E9084;
}

.st340 {
  clip-path: url(#SVGID_00000026868837313716732980000016292697942272020872_);
}

.st341 {
  clip-path: url(#SVGID_00000102528096866246355380000017854631158984583855_);
  fill: #165748;
}

.st342 {
  clip-path: url(#SVGID_00000005243239319718580060000007096852409033142197_);
}

.st343 {
  clip-path: url(#SVGID_00000098914815665205568990000013112151316307185544_);
  fill: #165748;
}

.st344 {
  clip-path: url(#SVGID_00000073712988454786052450000007402207745757579192_);
}

.st345 {
  clip-path: url(#SVGID_00000105403802114407482190000015016012340745215679_);
  fill: #EBEAE6;
}

.st346 {
  clip-path: url(#SVGID_00000021099228800507357250000011879368791960036778_);
}

.st347 {
  clip-path: url(#SVGID_00000103976570183664956070000016157935715146534590_);
  fill: #DCDDD7;
}

.st348 {
  clip-path: url(#SVGID_00000174582910874308964690000000797293379766586512_);
}

.st349 {
  clip-path: url(#SVGID_00000099649323281753446230000000909432361173067697_);
  fill: #868B89;
}

.st350 {
  clip-path: url(#SVGID_00000072999725451024985340000010395614816692375720_);
}

.st351 {
  clip-path: url(#SVGID_00000041269788148105221350000009668658293995422655_);
  fill: #DCDDD7;
}

.st352 {
  clip-path: url(#SVGID_00000004524011859116390630000007526394756181713285_);
}

.st353 {
  clip-path: url(#SVGID_00000135659434496968152530000003067131570540145340_);
  fill: #999C9A;
}

.st354 {
  clip-path: url(#SVGID_00000181788900722475517070000011739984608397374398_);
}

.st355 {
  clip-path: url(#SVGID_00000163070345676516716940000000048005372247550131_);
  fill: #999C9A;
}

.st356 {
  clip-path: url(#SVGID_00000012457866232314161590000009989261794532538543_);
}

.st357 {
  clip-path: url(#SVGID_00000129888837007795466050000013406342820910343301_);
  fill: #98CAB7;
}

.st358 {
  clip-path: url(#SVGID_00000029747054390947135580000008501138562196998563_);
}

.st359 {
  clip-path: url(#SVGID_00000160188185089516283850000001007635535617572024_);
  fill: #6E9A8A;
}

.st360 {
  clip-path: url(#SVGID_00000116211721815135034820000005126527200568048559_);
}

.st361 {
  clip-path: url(#SVGID_00000145746578809179419990000001435135879646863551_);
  fill: #6B59A6;
}

.st362 {
  clip-path: url(#SVGID_00000127046317129442271880000007583750897650072244_);
}

.st363 {
  clip-path: url(#SVGID_00000084509239911168032430000004643811522552210078_);
  fill: #699085;
}

.st364 {
  clip-path: url(#SVGID_00000121982053633908353870000002499333577531300520_);
}

.st365 {
  clip-path: url(#SVGID_00000125576168727355277570000011094792287810837679_);
  fill: #98CAB7;
}

.st366 {
  clip-path: url(#SVGID_00000004530897155383572320000000649049040694534025_);
}

.st367 {
  clip-path: url(#SVGID_00000055696467343124302800000009296935004184949689_);
  fill: #679384;
}

.st368 {
  clip-path: url(#SVGID_00000178170137568582918500000010230378751322987178_);
}

.st369 {
  clip-path: url(#SVGID_00000183238082016598104720000002871834728152855231_);
  fill: #6B59A6;
}

.st370 {
  clip-path: url(#SVGID_00000117658637389460413960000006676739836867471775_);
}

.st371 {
  clip-path: url(#SVGID_00000040538958135280515510000013693274715699110573_);
  fill: #6B59A6;
}

.st372 {
  clip-path: url(#SVGID_00000131351011782094518730000010274836222674583699_);
}

.st373 {
  clip-path: url(#SVGID_00000118379644797455091990000011434931502288551860_);
  fill: #6B59A6;
}

.st374 {
  clip-path: url(#SVGID_00000149359571692001873940000008485752139883857829_);
}

.st375 {
  clip-path: url(#SVGID_00000175320121585251002980000005373542581724415129_);
  fill: #6B59A6;
}

.st376 {
  clip-path: url(#SVGID_00000121265354247895739340000014519587547881565887_);
}

.st377 {
  clip-path: url(#SVGID_00000103262232711694195250000008148075275076159383_);
  fill: #547E6F;
}

.st378 {
  clip-path: url(#SVGID_00000070092736195756037590000016938448345687922563_);
}

.st379 {
  clip-path: url(#SVGID_00000030489260202082180060000006003693097932237215_);
  fill: #C7D9D0;
}

.st380 {
  clip-path: url(#SVGID_00000152965874331290259190000017997479972683141768_);
}

.st381 {
  clip-path: url(#SVGID_00000160908505591710622490000011503262905662363545_);
  fill: #C7D9D0;
}

.st382 {
  clip-path: url(#SVGID_00000160876282716662139510000010571020268324135556_);
}

.st383 {
  clip-path: url(#SVGID_00000173121836282521655330000002497077977390738842_);
  fill: #C7D9D0;
}

.st384 {
  fill: #E0E1DB;
}

.st385 {
  clip-path: url(#SVGID_00000139973717294552501490000016473636854298700476_);
}

.st386 {
  clip-path: url(#SVGID_00000067947300074553172380000011679758576121813909_);
  enable-background: new;
}

.st387 {
  clip-path: url(#SVGID_00000155125194094555950160000001423262057252661676_);
}

.st388 {
  clip-path: url(#SVGID_00000060017111550202156240000006724344584256790964_);
}

.st389 {
  opacity: 0;
  clip-path: url(#SVGID_00000097477285168512742410000005141139028669595582_);
}

.st390 {
  clip-path: url(#SVGID_00000122699415039458322240000009473475354435603391_);
}

.st391 {
  clip-path: url(#SVGID_00000018951956998760247730000016546179343152891839_);
}

.st392 {
  clip-path: url(#SVGID_00000013907900984136226290000008297130984377290135_);
  fill: #6B59A6;
}

.st393 {
  clip-path: url(#SVGID_00000069397434102549317310000002757741839601778603_);
}

.st394 {
  clip-path: url(#SVGID_00000165921473694725769940000015430389589343144622_);
  enable-background: new;
}

.st395 {
  clip-path: url(#SVGID_00000102529555667643191930000015247470386743078324_);
}

.st396 {
  clip-path: url(#SVGID_00000124158757005702435610000002856855998549924995_);
}

.st397 {
  opacity: 0;
  clip-path: url(#SVGID_00000044893610592487428840000011886324939914057614_);
}

.st398 {
  clip-path: url(#SVGID_00000122715654475872607610000015423252383803063725_);
}

.st399 {
  clip-path: url(#SVGID_00000067936197609202210390000011135811879384835483_);
}

.st400 {
  clip-path: url(#SVGID_00000038392261017643683920000017936163305926549168_);
  fill: #3E3F6F;
}

.st401 {
  opacity: 0.1;
}

.st402 {
  fill: #1F715C;
}

.st403 {
  fill: #A5B5BB;
}

.st404 {
  fill: #49BD99;
}

.st405 {
  fill: #2A2C2F;
}

.st406 {
  fill: #FFFFFF;
}

.st407 {
  fill: #434648;
}

.st408 {
  fill: #231F20;
}

.st409 {
  fill: #14604E;
}

.st410 {
  opacity: 0.8;
  fill: #2A2C2F;
}

.st411 {
  fill: #79AA9D;
}

.st412 {
  fill: url(#SVGID_00000005235094076795488630000018382812946458536889_);
}

.st413 {
  fill: #AFB4C4;
}

.st414 {
  fill: url(#SVGID_00000109732189439348172120000002761047365914415801_);
}

.st415 {
  fill: #EEF0F5;
}

.st416 {
  fill: #C8CEDB;
}

.st417 {
  enable-background: new;
}

.st418 {
  clip-path: url(#SVGID_00000014603864474986197030000017918974924637122232_);
  enable-background: new;
}

.st419 {
  fill: #0D3F33;
}

.st420 {
  clip-path: url(#SVGID_00000181084212332965196980000013318817964214675899_);
  enable-background: new;
}

.st421 {
  fill: #0A3229;
}

.st422 {
  fill: #115444;
}

.st423 {
  fill: #0A3027;
}

.st424 {
  clip-path: url(#SVGID_00000066511576900181802210000017251831861368797331_);
  enable-background: new;
}

.st425 {
  fill: #0C3A2F;
}

.st426 {
  fill: #0C3C30;
}

.st427 {
  fill: #0D3D32;
}

.st428 {
  fill: #0C382D;
}

.st429 {
  fill: #0B362C;
}

.st430 {
  fill: #0B342A;
}

.st431 {
  opacity: 0.7;
}

.st432 {
  clip-path: url(#SVGID_00000181080240599577772700000014870863513761408440_);
  enable-background: new;
}

.st433 {
  fill: #608E80;
}

.st434 {
  clip-path: url(#SVGID_00000023259622389260322950000010904544946062895517_);
  enable-background: new;
}

.st435 {
  fill: #588174;
}

.st436 {
  fill: #5B8578;
}

.st437 {
  fill: #5D8A7C;
}

.st438 {
  clip-path: url(#SVGID_00000034804991077374460360000009956159194333873050_);
  enable-background: new;
}

.st439 {
  fill: #557D71;
}

.st440 {
  fill: #52786D;
}

.st441 {
  fill: #4F7469;
}

.st442 {
  fill: #4C7065;
}

.st443 {
  clip-path: url(#SVGID_00000081639209204605768560000016468653853879963011_);
  enable-background: new;
}

.st444 {
  clip-path: url(#SVGID_00000113346720761163166070000005786513208550964923_);
  enable-background: new;
}

.st445 {
  clip-path: url(#SVGID_00000008140480549026839330000006559909964039460493_);
  enable-background: new;
}

.st446 {
  clip-path: url(#SVGID_00000050635783222864030340000013571415306959185287_);
  enable-background: new;
}

.st447 {
  clip-path: url(#SVGID_00000129924031963587692390000011364374014377937303_);
  enable-background: new;
}

.st448 {
  clip-path: url(#SVGID_00000048467014382710433260000007625766034594181765_);
  enable-background: new;
}

.st449 {
  clip-path: url(#SVGID_00000031886756719711265990000013345877789872062082_);
  enable-background: new;
}

.st450 {
  fill: #7FBCA9;
}

.st451 {
  clip-path: url(#SVGID_00000000200586704000170460000003225698664193261981_);
  enable-background: new;
}

.st452 {
  fill: #496C61;
}

.st453 {
  fill: #255F4D;
}

.st454 {
  clip-path: url(#SVGID_00000075850517534775359260000013819839309153178781_);
  enable-background: new;
}

.st455 {
  fill: #307D65;
}

.st456 {
  fill: #2F7962;
}

.st457 {
  fill: #2D755F;
}

.st458 {
  clip-path: url(#SVGID_00000053522841328408731920000007618123861785599408_);
  enable-background: new;
}

.st459 {
  fill: #266250;
}

.st460 {
  fill: #276653;
}

.st461 {
  fill: #296A56;
}

.st462 {
  fill: #2A6E59;
}

.st463 {
  fill: #2C715C;
}

.st464 {
  fill: #40A586;
}

.st465 {
  clip-path: url(#SVGID_00000158023963923754290670000018429963920769219512_);
  enable-background: new;
}

.st466 {
  clip-path: url(#SVGID_00000166651130129787115700000007517312527183413389_);
  enable-background: new;
}

.st467 {
  clip-path: url(#SVGID_00000042722499270946768480000013953901029928969382_);
  enable-background: new;
}

.st468 {
  clip-path: url(#SVGID_00000171684893584761827660000012098726229006022560_);
  enable-background: new;
}

.st469 {
  clip-path: url(#SVGID_00000181082420666263655810000003353649191025701017_);
  enable-background: new;
}

.st470 {
  clip-path: url(#SVGID_00000068636390088099114360000003392740409679742092_);
  enable-background: new;
}

.st471 {
  clip-path: url(#SVGID_00000047738626583784683040000005934721434158149007_);
  enable-background: new;
}

.st472 {
  clip-path: url(#SVGID_00000117636976399892036600000008758348765603584698_);
  enable-background: new;
}

.st473 {
  clip-path: url(#SVGID_00000146464536467110744520000009232351321877651362_);
  enable-background: new;
}

.st474 {
  clip-path: url(#SVGID_00000101082990714393885450000000010044130626299045_);
  enable-background: new;
}

.st475 {
  fill: #33836A;
}

.st476 {
  fill: url(#SVGID_00000044899840616185328840000000294514542610437256_);
}

.st477 {
  fill: url(#SVGID_00000183221393178008742830000011306637196847463052_);
}

.st478 {
  fill: url(#SVGID_00000009554534197506721530000000063280963883777193_);
}

.st479 {
  fill: url(#SVGID_00000003791227488044600210000008445366295839961221_);
}

.st480 {
  fill: url(#SVGID_00000077322376907790442240000008108412964914883756_);
}

.st481 {
  fill: url(#SVGID_00000060744640206797689680000015384737936075953835_);
}

.st482 {
  fill: url(#SVGID_00000134956177511966751110000010808944002221886624_);
}

.st483 {
  fill: url(#SVGID_00000172421405997122555400000015236969141354352806_);
}

.st484 {
  fill: url(#SVGID_00000023252281727531422940000008937152583613629071_);
}

.st485 {
  fill: url(#SVGID_00000024722300575650748410000013547404226637156284_);
}

.st486 {
  fill: url(#SVGID_00000116210044660011124700000006444428333504367493_);
}

.st487 {
  fill: url(#SVGID_00000031177894107490819080000005960071222693298833_);
}

.st488 {
  fill: url(#SVGID_00000034063141419162098710000016757849347149712311_);
}

.st489 {
  fill: url(#SVGID_00000051381615791050522050000008930715982166182546_);
}

.st490 {
  fill: url(#SVGID_00000169554199793519379110000001957915252276223375_);
}

.st491 {
  fill: url(#SVGID_00000024002935591817149300000007646389386614980028_);
}

.st492 {
  fill: url(#SVGID_00000038399324181554238060000011387653302561464209_);
}

.st493 {
  fill: url(#SVGID_00000017494737408617045670000016917670336971802753_);
}

.st494 {
  fill: url(#SVGID_00000133488585715923303060000007741983265965843099_);
}

.st495 {
  fill: url(#SVGID_00000152245132936579803030000016859330574959484058_);
}

.st496 {
  fill: url(#SVGID_00000045612591462418388560000002687839137112677521_);
}

.st497 {
  fill: url(#SVGID_00000136379248438826159970000013340215249274954374_);
}

.st498 {
  fill: url(#SVGID_00000039853244582730460120000017815852809146080423_);
}

.st499 {
  fill: url(#SVGID_00000039113541352520095400000000583677600908916398_);
}

.st500 {
  fill: url(#SVGID_00000119082546882499904850000010678241318490090922_);
}

.st501 {
  fill: url(#SVGID_00000077308067324594755330000011939410648156359612_);
}

.st502 {
  fill: url(#SVGID_00000048488344264379773570000008148544801260897409_);
}

.st503 {
  fill: url(#SVGID_00000095303302717248066370000010214424480723755676_);
}

.st504 {
  fill: url(#SVGID_00000094615065436731323310000015886145653050348974_);
}

.st505 {
  fill: url(#SVGID_00000034792702957795794850000009616238323316943783_);
}

.st506 {
  fill: url(#SVGID_00000152241017262860486150000002354985257434096525_);
}

.st507 {
  fill: url(#SVGID_00000119810478668876165580000014270696145943446954_);
}

.st508 {
  fill: url(#SVGID_00000132065927292257716310000002523074612326587041_);
}

.st509 {
  fill: url(#SVGID_00000003098638107532491260000000087636824276125109_);
}

.st510 {
  fill: url(#SVGID_00000061461639048397657190000000272400089949520772_);
}

.st511 {
  fill: url(#SVGID_00000059294486384069458350000013538936415487367598_);
}

.st512 {
  fill: url(#SVGID_00000052071324722537938240000005325422036261064864_);
}

.st513 {
  fill: url(#SVGID_00000176008228437325628670000003259119051057085833_);
}

.st514 {
  fill: url(#SVGID_00000018933952855838087840000014591538872530815934_);
}

.st515 {
  fill: url(#SVGID_00000175300990183322232170000010955661496009904023_);
}

.st516 {
  fill: url(#SVGID_00000075859927920371584620000017370497450775278475_);
}

.st517 {
  fill: url(#SVGID_00000032648409516322786070000012577976109522389149_);
}

.st518 {
  fill: url(#SVGID_00000103235197770699017780000017861849041117015179_);
}

.st519 {
  fill: url(#SVGID_00000039847572974203224040000008185176599086914461_);
}

.st520 {
  fill: url(#SVGID_00000111879830494434174460000007691958867275077761_);
}

.st521 {
  fill: url(#SVGID_00000092416990343668683380000005909846683484398003_);
}

.st522 {
  fill: url(#SVGID_00000052105646200044705360000013162693922271143566_);
}

.st523 {
  fill: url(#SVGID_00000143597746189774777640000000755082795780754617_);
}

.st524 {
  fill: url(#SVGID_00000128465873242171062970000000448252832785206925_);
}

.st525 {
  fill: url(#SVGID_00000046314213173001920470000011752175635167282103_);
}

.st526 {
  fill: url(#SVGID_00000121995847795859366860000004571934767440335020_);
}

.st527 {
  fill: url(#SVGID_00000062149880180526155340000010084999678254819717_);
}

.st528 {
  fill: url(#SVGID_00000040544510964873204660000017550296861450697903_);
}

.st529 {
  fill: url(#SVGID_00000026885158117776874870000004260667558874528434_);
}

.st530 {
  fill: url(#SVGID_00000083080475204597812120000001419418383055803522_);
}

.st531 {
  fill: url(#SVGID_00000158726689442194638190000011507879729450542735_);
}

.st532 {
  fill: url(#SVGID_00000106136599435770675050000004840207676336784037_);
}

.st533 {
  fill: url(#SVGID_00000103961685503453210230000002505197443770902919_);
}

.st534 {
  fill: url(#SVGID_00000034065245194638738780000007226164007237953414_);
}

.st535 {
  fill: url(#SVGID_00000097475077023346932310000007115896324789474465_);
}

.st536 {
  fill: url(#SVGID_00000101092106952141159760000010896028532150160516_);
}

.st537 {
  fill: url(#SVGID_00000048467611984810431400000013778600542369267080_);
}

.st538 {
  fill: url(#SVGID_00000049179654139690238000000008730193308933250974_);
}

.st539 {
  fill: url(#SVGID_00000096025989748445938010000004389503562276247193_);
}

.st540 {
  fill: url(#SVGID_00000026870925675783504180000007642772474579593388_);
}

.st541 {
  fill: url(#SVGID_00000025417543668229760370000015066365650377660812_);
}

.st542 {
  fill: url(#SVGID_00000183932263969625578290000009417506728216506517_);
}

.st543 {
  fill: url(#SVGID_00000141431143901387028200000017911545317298534039_);
}

.st544 {
  fill: url(#SVGID_00000008143515797019793550000006334849089458169523_);
}

.st545 {
  fill: url(#SVGID_00000038403558671678966860000016727173434367083696_);
}

.st546 {
  fill: url(#SVGID_00000015344089471730482530000008588795041928969352_);
}

.st547 {
  fill: url(#SVGID_00000129174406108495863120000001776484512918818696_);
}

.st548 {
  fill: url(#SVGID_00000179616031590769792860000005057572669199637695_);
}

.st549 {
  fill: url(#SVGID_00000103225822914466736600000002542304003431899012_);
}

.st550 {
  fill: url(#SVGID_00000064353598980189046570000012484683759861472698_);
}

.st551 {
  fill: url(#SVGID_00000143588312393466246710000002843352487497573778_);
}

.st552 {
  fill: url(#SVGID_00000149377108363762233740000012336529951546756790_);
}

.st553 {
  fill: url(#SVGID_00000178199484731475015360000012656943423316097453_);
}

.st554 {
  fill: url(#SVGID_00000089563032854149395950000014832273789986254776_);
}

.st555 {
  fill: url(#SVGID_00000128473330634119426650000011050662909662264505_);
}

.st556 {
  fill: url(#SVGID_00000036935331679354247750000000302140753750439847_);
}

.st557 {
  fill: url(#SVGID_00000000209997210825741310000012145480557670799758_);
}

.st558 {
  fill: url(#SVGID_00000094611305386702909900000005006046522538481583_);
}

.st559 {
  opacity: 0.2;
}

.st560 {
  opacity: 9.090909e-02;
}

.st561 {
  opacity: 0.1818;
}

.st562 {
  opacity: 0.2727;
}

.st563 {
  opacity: 0.3636;
}

.st564 {
  opacity: 0.4545;
}

.st565 {
  opacity: 0.5455;
}

.st566 {
  opacity: 0.6364;
}

.st567 {
  opacity: 0.7273;
}

.st568 {
  opacity: 0.8182;
}

.st569 {
  opacity: 0.9091;
}

.st570 {
  fill: url(#SVGID_00000103960752197958839680000008157343557777579667_);
}

.st571 {
  fill: url(#SVGID_00000108306529076572673120000005371795252075872395_);
}

.st572 {
  fill: url(#SVGID_00000004517202261748626760000018178238326045485959_);
}

.st573 {
  fill: url(#SVGID_00000019667146813526928840000001863968780888568489_);
}

.st574 {
  fill: url(#SVGID_00000152223044670734034710000010114512174041661594_);
}

.st575 {
  fill: #619788;
}

.st576 {
  fill: url(#SVGID_00000090996247311453970610000011217295552475198100_);
}

.st577 {
  fill: url(#SVGID_00000172439037456743477870000003339640030919066298_);
}

.st578 {
  fill: url(#SVGID_00000114043315386987737640000016257115317108373380_);
}

.st579 {
  fill: url(#SVGID_00000016076070945197103450000015068828519868238499_);
}

.st580 {
  fill: url(#SVGID_00000068671944545348404710000018438264882409176459_);
}

.st581 {
  fill: url(#SVGID_00000022532753095421121340000017365234880254720937_);
}

.st582 {
  fill: url(#SVGID_00000150099002125871236720000016724750748551186875_);
}

.st583 {
  fill: url(#SVGID_00000118375877626397328650000015629787385948048023_);
}

.st584 {
  fill: url(#SVGID_00000048462335661211212770000007220566324079093679_);
}

.st585 {
  fill: url(#SVGID_00000140693523228062799360000007217893368194223526_);
}

.st586 {
  opacity: 0.6;
  fill: #6B59A6;
}

.st587 {
  fill: url(#SVGID_00000035497161895047087210000016703173505982481589_);
}

.st588 {
  opacity: 0;
  fill: url(#SVGID_00000008145000297468610320000011141068027714388380_);
}

.st589 {
  opacity: 9.090909e-02;
  fill: url(#SVGID_00000104702657748138493030000016512092284995798184_);
}

.st590 {
  opacity: 0.1818;
  fill: url(#SVGID_00000004510968754087904700000002047828882062595464_);
}

.st591 {
  opacity: 0.2727;
  fill: url(#SVGID_00000152949260940346771400000014788811565177305247_);
}

.st592 {
  opacity: 0.3636;
  fill: url(#SVGID_00000100355864023664517270000000215275213356948104_);
}

.st593 {
  opacity: 0.4545;
  fill: url(#SVGID_00000051370489648213576710000013323435025817207956_);
}

.st594 {
  opacity: 0.5455;
  fill: url(#SVGID_00000008147181907331781110000000220790488971416245_);
}

.st595 {
  opacity: 0.6364;
  fill: url(#SVGID_00000061461893230166814190000010636410768530111879_);
}

.st596 {
  opacity: 0.7273;
  fill: url(#SVGID_00000083051906907379184020000004199022397512828044_);
}

.st597 {
  opacity: 0.8182;
  fill: url(#SVGID_00000104679847199848435120000008133047579798390205_);
}

.st598 {
  opacity: 0.9091;
  fill: url(#SVGID_00000047034037966569811820000010567250498686144653_);
}

.st599 {
  fill: url(#SVGID_00000161597750178591185130000009557046976645072777_);
}

.st600 {
  opacity: 0.7;
  fill: url(#SVGID_00000021115382837256314600000012681256335552847255_);
}

.st601 {
  opacity: 0.1;
  fill: url(#SVGID_00000013189057083367444310000014940659291561062324_);
}

.st602 {
  fill: url(#SVGID_00000072977674969313543860000009087425344731713199_);
}

.st603 {
  opacity: 0.5;
  fill: #2A2C2F;
}

.st604 {
  fill: url(#SVGID_00000148659779858983949900000001064078176478934165_);
}

.st605 {
  fill: #45494B;
}

.st606 {
  fill: #363B3D;
}

.st607 {
  fill: #5A5F60;
}

.st608 {
  fill: #35896F;
}

.st609 {
  clip-path: url(#SVGID_00000062165609961932460750000009380650505755307446_);
  enable-background: new;
}

.st610 {
  fill: #328168;
}

.st611 {
  fill: #33846B;
}

.st612 {
  fill: #35886E;
}

.st613 {
  fill: #368C71;
}

.st614 {
  fill: #379074;
}

.st615 {
  fill: #399377;
}

.st616 {
  fill: #3A977A;
}

.st617 {
  fill: #3C9B7D;
}

.st618 {
  fill: #3D9F81;
}

.st619 {
  fill: #3FA384;
}

.st620 {
  fill: #40A687;
}

.st621 {
  fill: #42AA8A;
}

.st622 {
  fill: #43AE8D;
}

.st623 {
  fill: #45B290;
}

.st624 {
  fill: #46B593;
}

.st625 {
  fill: #48B996;
}

.st626 {
  clip-path: url(#SVGID_00000169551643901632303740000018277905480572367240_);
  enable-background: new;
}

.st627 {
  clip-path: url(#SVGID_00000127003542052008475300000000068947075463589307_);
  enable-background: new;
}

.st628 {
  clip-path: url(#SVGID_00000100354319021233009550000015019721476123360691_);
  enable-background: new;
}

.st629 {
  clip-path: url(#SVGID_00000000926408686648162950000016228590554048670141_);
  enable-background: new;
}

.st630 {
  fill: #3EA081;
}

.st631 {
  clip-path: url(#SVGID_00000075873939499386256490000012926787728445569975_);
  enable-background: new;
}

.st632 {
  clip-path: url(#SVGID_00000086667445191459948020000000069712735356797593_);
  enable-background: new;
}

.st633 {
  clip-path: url(#SVGID_00000074435122281645775960000005794422929952963725_);
  enable-background: new;
}

.st634 {
  clip-path: url(#SVGID_00000058566985178504414740000003817949150324029572_);
  enable-background: new;
}

.st635 {
  clip-path: url(#SVGID_00000111896962699010058210000012740208409505945217_);
  enable-background: new;
}

.st636 {
  clip-path: url(#SVGID_00000130648976563124658220000002760870186543210932_);
  enable-background: new;
}

.st637 {
  clip-path: url(#SVGID_00000009572800620356831740000011266679524214942095_);
  enable-background: new;
}

.st638 {
  clip-path: url(#SVGID_00000042736207069089296510000018074159033454974868_);
  enable-background: new;
}

.st639 {
  fill: #3E9F81;
}

.st640 {
  fill: #2B715B;
}

.st641 {
  fill: #3D9E80;
}

.st642 {
  fill: #44B08E;
}

.st643 {
  clip-path: url(#SVGID_00000153702785357951650010000011718072567455951239_);
  enable-background: new;
}

.st644 {
  fill: #858585;
}

.st645 {
  fill: #8A8A8A;
}

.st646 {
  fill: #8F8F8F;
}

.st647 {
  fill: #949494;
}

.st648 {
  fill: #999999;
}

.st649 {
  fill: #9E9E9E;
}

.st650 {
  fill: #A3A3A3;
}

.st651 {
  fill: #A8A8A8;
}

.st652 {
  fill: #ADADAD;
}

.st653 {
  fill: #B3B3B3;
}

.st654 {
  fill: #B8B8B8;
}

.st655 {
  fill: #BDBDBD;
}

.st656 {
  fill: #C2C2C2;
}

.st657 {
  fill: #C7C7C7;
}

.st658 {
  fill: #CCCCCC;
}

.st659 {
  fill: #D1D1D1;
}

.st660 {
  fill: #D6D6D6;
}

.st661 {
  fill: #DBDBDB;
}

.st662 {
  fill: #E0E0E0;
}

.st663 {
  fill: #E6E6E6;
}

.st664 {
  fill: #EBEBEB;
}

.st665 {
  fill: #F0F0F0;
}

.st666 {
  fill: #F5F5F5;
}

.st667 {
  fill: #FAFAFA;
}

.st668 {
  clip-path: url(#SVGID_00000030487852996401430720000012910531630634840245_);
  enable-background: new;
}

.st669 {
  clip-path: url(#SVGID_00000104682174155944145970000006583020758088411801_);
  enable-background: new;
}

.st670 {
  clip-path: url(#SVGID_00000122708553577298520340000003820679493457243796_);
  enable-background: new;
}

.st671 {
  fill: #989898;
}

.st672 {
  clip-path: url(#SVGID_00000111881814423074081280000009015668943535671731_);
  enable-background: new;
}

.st673 {
  clip-path: url(#SVGID_00000102525772279156368610000008145244869625141896_);
  enable-background: new;
}

.st674 {
  fill: #D8D8D8;
}

.st675 {
  clip-path: url(#SVGID_00000075128648658211273510000002000239408340459448_);
  enable-background: new;
}

.st676 {
  clip-path: url(#SVGID_00000176757346680602072110000007287195381137976729_);
  enable-background: new;
}

.st677 {
  clip-path: url(#SVGID_00000034063212672128368360000015949925412058475138_);
  enable-background: new;
}

.st678 {
  clip-path: url(#SVGID_00000078748361063659044240000001986586454017190069_);
  enable-background: new;
}

.st679 {
  clip-path: url(#SVGID_00000013916072478730361020000011720812507165300126_);
  enable-background: new;
}

.st680 {
  clip-path: url(#SVGID_00000157996057800058718230000000332328904934711210_);
  enable-background: new;
}

.st681 {
  clip-path: url(#SVGID_00000041297730561715016370000003371746891422443153_);
  enable-background: new;
}

.st682 {
  clip-path: url(#SVGID_00000023989720045400430050000015243208650155276450_);
  enable-background: new;
}

.st683 {
  clip-path: url(#SVGID_00000051353820063966054580000009989244458766386053_);
  enable-background: new;
}

.st684 {
  clip-path: url(#SVGID_00000085959652659376753350000003636862159090357171_);
  enable-background: new;
}

.st685 {
  clip-path: url(#SVGID_00000028325051560475476750000006619515114567476131_);
  enable-background: new;
}

.st686 {
  clip-path: url(#SVGID_00000140706808966046884830000012551543451663013806_);
  enable-background: new;
}

.st687 {
  clip-path: url(#SVGID_00000129195806522275647290000007396436175993743264_);
  enable-background: new;
}

.st688 {
  clip-path: url(#SVGID_00000006692603416517411880000008559790741186330759_);
  enable-background: new;
}

.st689 {
  clip-path: url(#SVGID_00000029019891011533766820000007272077784424344982_);
  enable-background: new;
}

.st690 {
  clip-path: url(#SVGID_00000072972269570175139180000017612734122199425949_);
  enable-background: new;
}

.st691 {
  clip-path: url(#SVGID_00000084509275517124598030000005248754583564009616_);
  enable-background: new;
}

.st692 {
  clip-path: url(#SVGID_00000050626789534367637960000000837603246168289713_);
  enable-background: new;
}

.st693 {
  fill: #685AA1;
}

.st694 {
  fill: url(#XMLID_00000178178805522527267680000015510902534581701524_);
}

.st695 {
  fill: url(#XMLID_00000111913706207664918000000000585382128316432030_);
}

.st696 {
  fill: url(#XMLID_00000039847775270739347130000015971405003833389191_);
}

.st697 {
  fill: #F1F0F0;
}

.st698 {
  fill: url(#SVGID_00000028320781890382785720000012740206744033056431_);
}

.st699 {
  opacity: 0.8;
  fill: #455B64;
}

.st700 {
  fill: url(#SVGID_00000172435283701679113050000006730556268892941986_);
}

.st701 {
  fill: #3E3F6F;
}

.st702 {
  fill: #6B59A6;
}

.st703 {
  fill: #FAFBFB;
}

.st704 {
  fill: #58C2B1;
}

.st705 {
  opacity: 0.8;
  fill: #FAFBFB;
}

.st706 {
  fill: #455B64;
}

.st707 {
  opacity: 0.3;
}

.st708 {
  fill: #716F6F;
}

.st709 {
  fill: #C6C5C4;
}

.st710 {
  fill: url(#SVGID_00000018942455056129588440000001493125647112124036_);
}

.st711 {
  fill: #049AD0;
}

.st712 {
  fill: url(#SVGID_00000145019199561866016250000010151107017436123291_);
}

.st713 {
  fill: url(#SVGID_00000005241895903751956620000000569165773192474030_);
}

.st714 {
  fill: url(#SVGID_00000014611493197263599880000006632983472133620882_);
}

.st715 {
  fill: url(#SVGID_00000080908398690212839230000008876653902437743756_);
}

.st716 {
  fill: url(#SVGID_00000093877322923924104150000016524576316803998367_);
}

.st717 {
  fill: #1B6F5A;
}

.st718 {
  fill: #A382BB;
}

.st719 {
  opacity: 0.7;
  fill: #4ABD96;
}

.st720 {
  opacity: 0.6;
  fill: #1B6F5A;
}

.st721 {
  fill: url(#SVGID_00000110464318484619735180000011666065635950525102_);
}

.st722 {
  fill: url(#SVGID_00000099638943723518888860000014841571825448174233_);
}

.st723 {
  fill: url(#SVGID_00000127013538086116303040000008038457534531293620_);
}

.st724 {
  fill: url(#SVGID_00000126292155054730068640000017467277967389418644_);
}

.st725 {
  fill: url(#SVGID_00000014606397354158407230000005233700361124512171_);
}

.st726 {
  fill: url(#SVGID_00000057867589812333372470000014065121589928317846_);
}

.st727 {
  fill: #30B78D;
}

.st728 {
  fill: #F16C73;
}

.st729 {
  fill: #FDD500;
}

.st730 {
  opacity: 0.2;
  fill: #6B59A6;
}

.st731 {
  fill: url(#SVGID_00000155847758394921054440000007655027561196802699_);
}

.st732 {
  fill: url(#SVGID_00000132086420476106644510000004490637909555702202_);
}

.st733 {
  fill: url(#SVGID_00000095327564421761031200000000769759044550439853_);
}

.st734 {
  fill: url(#SVGID_00000159454467472648847750000003513135340344008888_);
}

.st735 {
  fill: url(#SVGID_00000116234493894710976760000007144126618436293774_);
}

.st736 {
  fill: url(#SVGID_00000112630567297219559600000013674742341951008655_);
}

.st737 {
  fill: #1F6F58;
}

.st738 {
  fill: url(#SVGID_00000111875924821891736680000015153609659419746738_);
}

.st739 {
  fill: url(#SVGID_00000123404680327198802450000007177643368919777938_);
}

.st740 {
  fill: url(#SVGID_00000052803204662865708920000004904918534256544641_);
}

.st741 {
  fill: url(#SVGID_00000054978294937211265800000003120899528056800435_);
}

.st742 {
  fill: url(#SVGID_00000103983598856649773890000008309443224338748563_);
}

.st743 {
  fill: url(#SVGID_00000080921326004203716870000006967404394000229019_);
}

.st744 {
  fill: #4ABD96;
}

.st745 {
  opacity: 0.1;
  fill: #4ABD96;
}

.st746 {
  opacity: 0.5;
}

.st747 {
  fill: url(#SVGID_00000064348044948271780180000017500599623622888635_);
}

.st748 {
  fill: url(#SVGID_00000181792242257836461200000009915040405607423122_);
}

.st749 {
  fill: url(#SVGID_00000155826598475473338740000018208901382029267087_);
}

.st750 {
  fill: #30302F;
}

.st751 {
  fill: url(#SVGID_00000179607648587485982280000009140554150746313102_);
}

.st752 {
  fill: url(#SVGID_00000052090619513986156040000010814993922911427769_);
}

.st753 {
  fill: url(#SVGID_00000063608787112302192820000011671157220210595006_);
}

.st754 {
  fill: url(#SVGID_00000085966194328672557500000014089313668161292209_);
}

.st755 {
  fill: url(#SVGID_00000078019151208555882310000015930821189061381281_);
}

.st756 {
  fill: url(#SVGID_00000052088164403667041530000004008012959731745699_);
}

.st757 {
  opacity: 0.5;
  fill: #FFFFFF;
}

.st758 {
  fill: url(#SVGID_00000114039433367587346210000001402312818426594456_);
}
</style>